export default {
  app: {
    name: "Snap Cab",
  },
  language: {
    label: "Language",
    en: "English",
    ar: "Arabic",
  },
  toolbar: {
    back: "Back",
    pendingRequests: "Pending requests",
    noPendingRequests: "No pending requests",
    logoutError: "Error (check console)",
    profile: "Profile",
    logout: "Logout",
  },
  orderCard: {
    discount: "Discount",
    voucher: "Voucher code",
    cancellationReason: "Customer cancellation reason",
    paidOnline: "Paid online",
    merchantAccount: "to account",
    transaction: "txn",
    chargedToBusiness: "Charged to business wallet",
    paidFromWallet: "Paid from wallet",
    walletRemaining: "remaining",
  },
  wallet: {
    cashTopup: "Add balance (cash)",
    manualAdjust: "Manual adjustment",
    add: "Add balance - Credit",
    remove: "Remove balance - Debit",
    channel: "Source",
    channelAdmin: "Manual (Admin)",
    channelCenter: "Charge center",
    channelHint: "Manual (Admin): credited directly by an admin. Charge center: paid in cash at a charge center.",
    cashTopupHint: "Add balance for a cash payment received (recorded as a top-up).",
    manualAdjustHint: "Increase or decrease the balance with a required reason (audited correction).",
    amount: "Amount (SYP)",
    direction: "Operation",
    reason: "Reason (required, audited)",
  },
  agent: {
    pageTitle: "Transfer Agent",
    searchTitle: "Search approved centers",
    searchHint: "Name, phone number, or serial id",
    search: "Search",
    balance: "Balance",
    lowBalance: "Low balance",
    disabled: "Disabled",
    lastRecharge: "Last recharge",
    rechargeTitle: "Recharge center balance",
    amount: "Amount",
    notes: "Notes",
    noGps: "Location unavailable (enable GPS)",
    recharge: "Recharge",
    rechargeConfirm: "Recharge {amount} SYP for {center}?",
    rechargeDone: "{center} recharged. New balance: {balance} SYP",
    recentRecharges: "Recent recharges",
    rechargedBy: "Recharged by",
    recentDriverTransfers: "Recent driver transfers",
    myOps: "My operations log",
    date: "Date",
    status: "Status",
    center: "Center",
    driver: "Driver",
    done: "Done",
    cancelled: "Cancelled",
    cancel: "Cancel operation",
    cancelReasonPrompt: "Cancellation reason?",
    cancelDone: "Operation cancelled and balance reversed",
  },
  reports: {
    pageTitle: "Reports",
    catalogTitle: "Report catalog",
    searchCatalog: "Search reports",
    backToCatalog: "Back to the catalog",
    refresh: "Refresh",
    apply: "Apply",
    print: "Print",
    total: "Total",
    period: "Period",
    dateBasis: "Date basis",
    generatedAt: "Generated at",
    warning: "Warning",
    note: "Note",
    notesTitle: "How to read this report",
    noRows: "No data for this period or these filters",
    noColumns: "No columns to display",
    noReportsPermitted: "No reports are available for your permissions",
    previous: "Previous",
    next: "Next",
    status: "Status",
    statusAll: "All",
    statusReady: "Ready",
    statusPartial: "Partial",
    statusLegacy: "Already published",
    statusBlocked: "Data unavailable",
    blockedHeading: "This report cannot be produced yet",
    blockedMissing: "Missing data",
    blockedRecommendation: "What it would take",
    noPermission: "You do not have permission to view this report",
    failedToLoad: "Failed to load the report",
    failedExport: "Failed to export the report",
  },
  finance: {
    nav: {
      settlements: "Settlements",
      chartOfAccounts: "Chart of Accounts",
      journalEntries: "Journal Entries",
      assets: "Assets & Capital",
      adjustments: "Adjustments",
      reports: "Reports",
      trialBalance: "Trial Balance",
      balanceSheet: "Balance Sheet",
      incomeStatement: "Income Statement",
      generalJournalSummary: "General Journal Summary",
      driverStatement: "Driver Statement (Trips)",
      cashFlowStatement: "Cash Flow Statement",
      equityChanges: "Changes in Equity",
      accountStatement: "Account Statement",
      accountingBalance: "Accounting Balance",
      accountsInventory: "Accounts Inventory",
      postingRules: "Auto Entries",
      periodLocks: "Period Locks",
      employees: "Employees & Payroll",
      // final-version doc 2026-10-05: grouped two-row finance nav.
      groups: {
        operations: "Daily operations",
        accountsSetup: "Accounts setup",
        ledgers: "Ledgers & reports",
        statements: "Financial statements",
      },
    },
    ui: {
      navLabel: "Finance sections",
    },
    postingRules: {
      pageTitle: "Automatic Journal Entries",
      rulesTab: "Posting Rules",
      failuresTab: "Posting Failures",
      depreciationTab: "Car Depreciation",
      engineOn: "Engine enabled",
      engineOff: "Engine disabled",
      eventKey: "Event",
      ruleName: "Operation",
      mapping: "Debit / Credit mapping",
      active: "Active",
      inactive: "Inactive",
      editMapping: "Edit accounts",
      editMappingHint: "Re-point any line to a different chart account. Clearing the override restores the default mapping. All changes are audited.",
      overrideAccount: "Override account",
      debit: "Debit",
      credit: "Credit",
      save: "Save",
      saved: "Mapping saved",
      failedSave: "Could not save the rule",
      failedLoad: "Could not load posting rules",
      manualEntry: "Post entry",
      operationRef: "Operation reference",
      memo: "Memo",
      post: "Post",
      posted: "Journal entry posted",
      failedPost: "Could not post the entry",
      retry: "Retry",
      retried: "Retried",
      reviewOnly: "Review - manual entry",
      reviewOnlyHint: "A confirmed online payment arrived after the ride was settled: the rider was charged and no automatic entry was posted. Review it and post a manual entry if needed.",
      error: "Error",
      carId: "Car ID",
      captainId: "Captain ID",
      carOwnerId: "Car owner ID",
      businessAccountId: "Business account ID",
      transferCenterId: "Charge center ID",
      paymentMethodCode: "Payment method code",
      car: "Car",
      monthlyAmount: "Monthly amount",
      startMonth: "Start month",
      endMonth: "End month",
      notes: "Notes",
      addSchedule: "Add schedule",
      runMonth: "Month (YYYY-MM)",
      runDepreciation: "Post depreciation",
      amountTotal: "Total",
      amountGateway: "Gateway amount",
      amountWallet: "Wallet amount",
      amountBusiness: "Business amount",
      amountCaptainNet: "Driver net (cash - share)",
      amountCaptainCashCollected: "Cash the driver collected",
      amountDiscount: "Voucher discount",
      amountCommission: "Commission revenue",
      amountCommissionThirdParty: "Commission (third-party car)",
      amountRideRevenue: "Ride revenue",
      amountDriverShare: "Driver share",
      amountOwnerShare: "Car owner share (2118)",
      amountStoreCommission: "Store commission",
      amountDeliveryFee: "Delivery fee",
      amountDriverDue: "Driver due",
      amountStoreDue: "Store due",
      resolver_captain_deferred: "Driver sub-account (auto)",
      resolver_captain_deferred_counterparty: "Receiving driver sub-account (auto)",
      resolver_center_deferred: "Charge-center sub-account (auto)",
      resolver_business_deferred: "Business sub-account (auto)",
      resolver_owner_payable: "Car-owner sub-account (auto)",
      resolver_company_captain_deferred: "Driver sub-account — company drivers (auto)",
      resolver_gateway_asset: "Gateway account (by payment method)",
      docRef: "Manual entry #",
      appliesWhen: "Applies when",
      entryKind: "Entry kind",
      kindAll: "All",
      kindManual: "Manual entries",
      kindAutomatic: "Automatic entries",
      amountCash: "Amount in cash (till)",
      amountBank: "Amount through the bank",
      amountGatewayChannel: "Amount through a payment gateway",
      amountNet: "Net amount transferred",
      amountGross: "Gross amount due",
      amountFee: "Payment gateway fee",
      amountGatewayNet: "Net amount at the gateway",
      amountCaptainShare: "Driver share (difference)",
      amountPlatformCommission: "Platform commission (Yalla Go)",
      amountCreditConsumed: "Platform credit consumed",
      amountCaptainFavour: "Difference in the driver favour",
      amountCenterFavour: "Difference in the charge-center favour",
      amountCompanyLoss: "Company loss",
      amountCompanyGain: "Company gain",
      resolver_center_receivable: "Charge-center receivable sub-account (auto)",
      accountMissing: "No matching account in the chart of accounts",
    },
    periodLocks: {
      pageTitle: "Period Locks",
      title: "Monthly Period Locks",
      monthsToShow: "Months shown",
      month: "Month",
      status: "Status",
      open: "Open",
      closed: "Closed",
      closedBy: "Closed by",
      closedAt: "Closed at",
      reopenedBy: "Reopened by",
      reopenedAt: "Reopened at",
      note: "Note",
      snapshots: "Frozen reports",
      close: "Close month",
      reopen: "Reopen",
      notClosable: "The month has not ended yet",
      openCount: "Open months",
      closedCount: "Closed months",
      closeTitle: "Close {month}",
      closeWarning: "Closing this month refuses every entry dated into it from now on \u2014 manual and automatic alike, with no re-dating \u2014 and freezes the snapshot of every financial report for the month, so whatever is issued today can always be reproduced with the same figures.",
      closeOrderHint: "Close the accounts (period close) first: its own entries are dated inside the period and are refused once the month is locked.",
      closeNote: "Closing note (optional)",
      closeConfirm: "Close the month",
      closeDone: "Month closed",
      reopenTitle: "Reopen {month}",
      reopenWarning: "Reopening lets an already-issued statement change: entries can be dated into the month again, and the figures the accountant published may stop matching the ledger.",
      reopenSnapshotNote: "The frozen snapshots survive a reopen and do not change, so what was issued stays reproducible. To issue new figures the month must be closed again after the correction.",
      reopenReason: "Reason for reopening (required)",
      reopenReasonRequired: "A reason is required to reopen a closed month.",
      reopenTypeToConfirm: "Type {month} to confirm",
      reopenTypeMismatch: "The typed month does not match.",
      reopenConfirm: "Reopen the month",
      reopenDone: "Month reopened",
      snapshotResult: "Freeze result for {month}",
      captured: "Frozen",
      failedSnapshots: "Could not be frozen",
      skipped: "Skipped \u2014 no data to freeze",
      warnings: "Warnings",
      earlierOpenMonths: "Earlier months still open",
      earlierOpenHint: "Closing out of order is allowed, but these earlier months are still open \u2014 check that this is intended.",
      snapshotCatalog: "Reports a close freezes",
      snapshotCatalogHint: "These are the reports whose figures are stored when a month is closed.",
      noMonths: "No months to show",
      failedLoad: "Could not load the period locks",
      failedClose: "Could not close the month",
      failedReopen: "Could not reopen the month",
    },
    employees: {
      pageTitle: "Employees & Payroll",
      title: "Employees",
      employeeNo: "Employee no.",
      fullName: "Full name",
      department: "Department",
      jobTitle: "Job title",
      phone: "Phone",
      hiredAt: "Hired",
      terminatedAt: "Terminated",
      basicSalary: "Basic salary (contract)",
      basicSalaryHint: "The contract figure. It seeds the month's basic component; it is never itself summed into a payroll report.",
      active: "Active",
      inactive: "Inactive",
      allDepartments: "All departments",
      allStatuses: "All",
      addEmployee: "Add employee",
      editEmployee: "Edit employee",
      newEmployee: "New employee",
      saved: "Employee saved",
      deleteTitle: "Remove employee",
      deleteWarning: "The employee is archived, not erased, and the payroll components already recorded for him are deliberately left behind so a month that was already paid keeps reconciling.",
      deleteConfirm: "Remove",
      deleted: "Employee removed",
      nameRequired: "The full name is required.",
      noEmployees: "No employees recorded",
      failedLoad: "Could not load the employees",
      failedSave: "Could not save the employee",
      failedDelete: "Could not remove the employee",
      payrollTitle: "Payroll sheet",
      payrollFor: "Payroll for {name}",
      selectEmployee: "Select an employee to open his payroll sheet",
      month: "Payroll month",
      kind: "Side",
      earning: "Earning",
      deduction: "Deduction",
      component: "Component",
      amount: "Amount",
      memo: "Memo",
      batch: "Paid in batch",
      addRow: "Add line",
      removeRow: "Remove line",
      saveMonth: "Save the month",
      replaceHint: "Saving rewrites this employee's whole month, so a corrected line does not leave the original behind to be summed twice.",
      monthSaved: "Payroll month saved",
      seedFromContract: "Seed from contract",
      seedHint: "Creates the basic component from the contract salary, and only for an employee who has nothing recorded for the month.",
      seedDone: "{created} component(s) created out of {considered} employee(s)",
      gross: "Gross earnings",
      deductionsTotal: "Total deductions",
      net: "Net pay",
      noComponents: "Nothing recorded for this month",
      deleteComponent: "Remove line",
      componentDeleted: "Line removed",
      amountRequired: "Every line needs a component and an amount.",
      lockedHint: "A closed month refuses payroll edits \u2014 reopen the period first if the change is genuinely needed.",
      failedLoadPayroll: "Could not load the payroll month",
      failedSaveMonth: "Could not save the payroll month",
      failedSeed: "Could not seed the month from the contract salaries",
      failedDeleteComponent: "Could not remove the line",
      components: {
        basic: "Basic",
        allowance: "Allowance",
        bonus: "Bonus",
        overtime: "Overtime",
        insurance: "Insurance",
        tax: "Tax",
        advance: "Advance",
        fine: "Fine",
        other: "Other",
      },
    },
    common: {
      performedBy: "Performed by",
      performedBySystem: "System (automatic)",
      from: "From",
      to: "To",
      amount: "Amount",
      apply: "Apply",
      back: "Back",
      refresh: "Refresh",
      search: "Search",
      load: "Load",
      csv: "CSV",
      pdf: "PDF",
      date: "Date",
      type: "Type",
      note: "Note",
      source: "Source",
      status: "Status",
      actions: "Actions",
      phone: "Phone",
      email: "Email",
      name: "Name",
      category: "Category",
      balance: "Balance",
      captain: "Captain",
      id: "ID",
      code: "Code",
      revenue: "Revenue",
      bonus: "Bonus",
      penalty: "Penalty",
      hrDeduction: "HR Deduction",
      net: "Net",
      settled: "Settled",
      credit: "Credit",
      debit: "Debit",
      memo: "Memo",
      account: "Account",
      cancel: "Cancel",
      reason: "Reason",
      all: "All",
      month: "Month",
    },
    assets: {
      pageTitle: "Assets & Capital",
      registerAsset: "Register Asset / Capital",
      entryType: "Entry Type",
      capitalInjection: "Capital Injection",
      vehiclePurchase: "Vehicle Purchase",
      assetPurchase: "Other Asset Purchase",
      assetAccount: "Asset Account",
      fundingAccount: "Funding Account",
      assetName: "Asset Name",
      assetCategory: "Asset Category",
      vendorName: "Source / Vendor",
      postDate: "Posting Date",
      recentEntries: "Recent Asset Entries",
      capitalTotal: "Capital Entries",
      vehicleTotal: "Vehicle Assets",
      otherAssetsTotal: "Other Assets",
      filters: "Filters",
      clearFilters: "Clear Filters",
      postEntry: "Post Asset Entry",
      assetPosted: "Asset entry posted",
      failedLoad: "Failed to load asset entries",
      failedPost: "Failed to post asset entry",
      requiredFields: "Asset account, funding account, amount, and asset name are required",
      assetEntrySource: "Asset / Capital Entry",
      status: "Status",
      originalEntry: "Original Entry",
    },
    payments: {
      pageTitle: "Settlements",
      addSettlement: "Add Settlement",
      paidToDriver: "Paid to driver",
      receivedFromDriver: "Received from driver",
      pending: "Pending",
      done: "Done",
      pendingPayments: "Pending Payments",
      donePayments: "Done Payments",
      firstName: "First Name",
      lastName: "Last Name",
      settlementSaved: "Settlement saved",
      failedLoadStatus: "Failed to load {status} payments",
      failedSaveSettlement: "Failed to save settlement",
    },
    ledger: {
      pageTitle: "Captain Ledger",
      entryType: "Entry Type",
      currentBalance: "Current Balance",
      restrictedBonus: "Remaining restricted welcome balance",
      restrictedBonusHint: "Covers the company commission only; never paid out in cash or transferred",
      withdrawableBalance: "Withdrawable balance",
      pendingBookings: "Pending Bookings",
      settledToDriver: "Settled To Driver",
      receivedFromDriver: "Received From Driver",
      booking: "Booking",
      balanceAfter: "Balance After",
      bookingRevenue: "Booking Revenue",
      settlement: "Settlement",
      adjustment: "Adjustment",
      failedLoadBalance: "Failed to load captain balance",
      failedLoadEntries: "Failed to load ledger entries",
      paidToDriver: "Paid To Driver",
      receivedFromDriverLabel: "Received From Driver",
    },
    coa: {
      kind: "Type",
      kindMain: "Main",
      kindSub: "Sub",
      kindClosing: "Closing",
      nature: "Account nature",
      natureBoth: "Debit & credit",
      natureNone: "None",
      level: "Level",
      closingAccount: "Closing account",
      closingAccountOptional: "Closing account (empty only for the balance sheet)",
      financialType: "Financial classification (reports)",
      allKinds: "All types",
      allNatures: "All natures",
      systemAccount: "System account",
      account: "Account",
      parentRequired: "A parent account is required for sub accounts",
      closingRequired: "A closing account is required for main and sub accounts",
      periodClose: "Period close",
      periodClosePreview: "Preview closing entries",
      periodCloseConfirm: "Post closing entries",
      periodCloseDone: "Closing entries created",
      periodCloseNothing: "No balances need closing for this period",
      pageTitle: "Chart of Accounts",
      chartOfAccounts: "Chart of Accounts",
      searchTree: "Search by code or name",
      expandAll: "Expand all",
      collapseAll: "Collapse all",
      addChild: "Add sub-account",
      includesChildren: "Total includes sub-accounts",
      noResults: "No matching accounts",
      addAccount: "Add Account",
      editAccount: "Edit Account",
      accountCode: "Account Code",
      accountNameEn: "Account Name (English)",
      accountNameAr: "Account Name (Arabic)",
      parentAccount: "Parent Account",
      noParent: "No Parent",
      description: "Description",
      manualPosting: "Allow Manual Posting",
      saveAccount: "Save Account",
      accountSaved: "Account saved",
      failedSave: "Failed to save account",
      codeConflictTitle: "Code already in use",
      codeConflictBody: 'Code {code} is currently used by "{name}".',
      swapCodesHint:
        "You can swap the two codes: this account takes the new code and the other account takes this account's current code.",
      swapCodes: "Swap codes",
      requiredFields: "Account code, English name, type, and normal balance are required",
      typeAsset: "Asset",
      typeLiability: "Liability",
      typeEquity: "Equity",
      typeRevenue: "Revenue",
      typeExpense: "Expense",
      balanceDebit: "Debit",
      balanceCredit: "Credit",
      normalBalance: "Normal Balance",
      debitTotal: "Debit Total",
      creditTotal: "Credit Total",
      active: "Active",
      inactive: "Inactive",
      failedLoad: "Failed to load chart of accounts",
      deleteAccount: "Delete account",
      deleteConfirmTitle: "Confirm account deletion",
      deleteConfirmBody: 'Account {code} — "{name}" will be permanently deleted. Are you sure?',
      deleteBlockedSystem: "This is a system account used by automated postings and cannot be deleted — rename or move it in the tree instead.",
      deleteBlockedChildren: "An account with sub-accounts cannot be deleted — delete or move its sub-accounts first.",
      accountDeleted: "Account deleted",
      failedDelete: "Failed to delete account",
      exportedAt: "Exported at",
    },
    adjustments: {
      pageTitle: "Captain Adjustments",
      captainAdjustments: "Captain Adjustments",
      adjustmentType: "Adjustment Type",
      postingDate: "Posting Date",
      postAdjustment: "Post Adjustment",
      recentAdjustmentJournals: "Recent Adjustment Journals",
      captainAmountRequired: "Captain and amount are required",
      adjustmentPosted: "Adjustment posted",
      failedPost: "Failed to post adjustment",
      failedLoad: "Failed to load adjustments",
      accountCodeSearch: "Search by account no.",
      lineAccounts: "Account codes",
    },
    journals: {
      pageTitle: "Journal Entries",
      operationRef: "Operation No.",
      bookingId: "Booking ID",
      newCashMovement: "New Cash Movement",
      direction: "Direction",
      counterAccount: "Counter Account",
      captainOptional: "Captain (optional)",
      referenceNo: "Reference No",
      postingDate: "Posting Date",
      newPayrollBatch: "New Payroll Batch",
      paidAt: "Paid At",
      recipient: "Recipient",
      lineMemo: "Line Memo",
      addPayrollLine: "Add Payroll Line",
      total: "Total",
      newJournalEntry: "New Journal Entry",
      journalDate: "Journal Date",
      addLine: "Add Line",
      postEntry: "Post Entry",
      postCashMovement: "Post Cash Movement",
      postPayrollBatch: "Post Payroll Batch",
      noMemo: "No memo",
      reset: "Reset",
      manualJournals: "Manual Journals",
      bookingRevenue: "Booking Revenue",
      settlementPaid: "Settlement Paid",
      settlementReceived: "Settlement Received",
      bonusAdjustments: "Bonus Adjustments",
      penaltyAdjustments: "Penalty Adjustments",
      hrDeductions: "HR Deductions",
      cashMovements: "Cash Movements",
      payrollBatches: "Payroll Batches",
      assetEntries: "Asset Entries",
      cashIn: "Cash In",
      cashOut: "Cash Out",
      debitCreditMustMatch: "Debit and credit totals must match",
      journalPosted: "Journal entry posted",
      failedPostJournal: "Failed to post journal entry",
      accountAmountRequired: "Account and amount are required",
      cashMovementPosted: "Cash movement posted",
      failedCashMovement: "Failed to post cash movement",
      payrollGreaterThanZero: "Payroll batch total must be greater than zero",
      payrollPosted: "Payroll batch posted",
      failedPayroll: "Failed to post payroll batch",
      failedLoad: "Failed to load journal entries",
      reverseEntry: "Reverse Entry",
      reverseEntryTitle: "Reverse Journal Entry",
      reverseReasonHint: "Explain why this entry is being reversed",
      reverseEntryConfirm: "Post Reversal",
      reversePosted: "Reversal entry posted",
      failedReverse: "Failed to reverse journal entry",
      statusPosted: "Posted",
      statusReversed: "Reversed",
      statusReversal: "Reversal Entry",
      reversedBy: "Reversed by",
      reversalOf: "Reversal of",
      reversalSource: "Reversal",
      failedLoadAccounts: "Could not load the chart of accounts",
      useDriverAccount: "Use the driver's account {code}",
      driverHasNoAccount: "This driver has no sub-account yet",
      entityLeafWarning: "Posts to the general ledger only; it does not change the driver/center wallet balance in the app",
      payrollMode: "Posting mode",
      payrollModePaid: "Accrue and pay",
      payrollModeAccrued: "Accrue only",
      payrollModePaidHint: "An accrual entry (Dr payroll / Cr beneficiary) then a payment entry (Dr beneficiary / Cr cash or bank)",
      payrollModeAccruedHint: "An accrual entry on the beneficiary account only; paid later",
      payrollCreditAccount: "Paying account (cash box or bank)",
      payrollCreditAccountHint: "Leave empty to pay from the main cash box",
      beneficiaryType: "Beneficiary type",
      employee: "Employee",
      driver: "Driver",
      freeTextBeneficiary: "Name only",
      freeTextBeneficiaryHint: "No sub-account: the name goes into the memo and the line is credited to the paying account directly",
      noEmployees: "No employees yet; add them on the Employees screen",
      failedLoadEmployees: "Could not load the employees list",
      payrollDriverAccount: "Posts to the driver's account {code}",
      payrollDriverAccountNew: "The driver's sub-account will be created on posting",
      payrollRecipientRequired: "Choose an employee or a driver, or type the recipient name, on every line",
      payrollResultTitle: "The following entries were posted:",
      closeDialog: "Close",
      searchText: "Search (reference, memo, recipient)",
      entriesTotal: "Entries: {count}",
      perPage: "Per page",
      // final-version doc 2026-10-05 ("one hour difference"): the entry date
      // is the operation date; the recording time is when the entry was made.
      recordedAt: "Recorded at",
      recordedAtHint: "The entry date is when the operation took place (for a ride: when it finished); the recording time is when the entry was created (for a ride: when it was paid)",
    },
    reports: {
      pageTitle: "Finance Reports",
      trialBalance: "Trial Balance",
      captainStatement: "Captain Statement",
      monthlySettlements: "Monthly Settlements",
      loadTrialBalance: "Load Trial Balance",
      selectCaptainFirst: "Select a captain first",
      failedLoadTrialBalance: "Failed to load trial balance",
      failedLoadCaptainStatement: "Failed to load captain statement",
      failedLoadMonthlySettlements: "Failed to load monthly settlements",
      failedDownloadReport: "Failed to download report",
      bookingRevenue: "Booking Revenue",
      settledToDriver: "Settled To Driver",
      receivedFromDriver: "Received From Driver",
      captainId: "Captain ID",
      driverAccountCode: "Driver account no.",
      entry: "Entry",
    },
    trialBalance: {
      pageTitle: "Trial Balance",
      title: "Trial Balance",
      openFullReport: "Open Full Report",
      debitMovements: "Debit Movements",
      creditMovements: "Credit Movements",
      balanceSide: "Balance Side",
      sideDebit: "Debit",
      sideCredit: "Credit",
      sideBalanced: "Balanced",
      notes: "Notes",
      totals: "Totals",
      totalDebit: "Total Debit Movements",
      totalCredit: "Total Credit Movements",
      totalsMatch: "Totals match",
      totalsMismatch: "Totals do not match",
      totalsMismatchWarning: "Total debit movements do not equal total credit movements — please review.",
      difference: "Difference",
      abnormalCount: "Abnormal balances",
      codeFrom: "From account (code)",
      codeTo: "To account (code)",
      maxLevel: "Up to level",
      allLevels: "All levels",
      contextRow: "Shown to keep the tree readable (outside the filter)",
      printPdf: "Print / PDF",
      noteAssetCredit: "A credit balance on an asset account is rare and may indicate a problem — please review.",
      noteLiabilityDebit: "A debit balance on a liability account is rare and may indicate a problem — please review.",
      noteExpenseCredit: "Expense accounts should always carry a debit balance — please review.",
    },
    balanceSheet: {
      pageTitle: "Balance Sheet",
      title: "Balance Sheet",
      asOfDate: "As of date",
      currency: "Currency",
      currencyNew: "New currency",
      currencyOld: "Old currency",
      item: "Item",
      value: "Value",
      totalAssets: "Total assets",
      totalLiabilities: "Total liabilities",
      totalEquity: "Total equity",
      currentPeriodResult: "Current period result (not yet closed)",
      computedNote: "Computed from the un-closed revenue and expense accounts",
      netOfProvision: "Net of {name} ({amount})",
      liabilitiesPlusEquity: "Liabilities + equity",
      balancedMessage: "The equation balances (Assets = Liabilities + Equity).",
      unbalancedMessage: "The equation does not balance — please review the journal entries.",
      balancedShort: "Balanced",
      unbalancedShort: "Not balanced",
      failedLoad: "Failed to load the balance sheet",
    },
    incomeStatement: {
      pageTitle: "Income Statement",
      title: "Income Statement",
      fromDate: "From date",
      toDate: "To date",
      comparison: "Comparison",
      comparisonNone: "No comparison",
      comparisonPreviousPeriod: "Previous period",
      comparisonPreviousYear: "Same period last year",
      comparisonNeedsDates: "A comparison requires both period dates",
      item: "Item",
      currentPeriod: "Current period",
      previousPeriod: "Previous period",
      change: "Change",
      sections: {
        operating_revenue: "Operating revenue",
        cost_of_revenue: "Direct operating expenses (cost of revenue)",
        general_admin: "Indirect operating expenses (general & administrative)",
        non_operating_revenue: "Non-operating revenue",
        non_operating_expense: "Non-operating expenses",
      },
      subtotals: {
        operating_revenue: "Total operating revenue",
        cost_of_revenue: "Total cost of revenue",
        general_admin: "Total general & administrative expenses",
        non_operating_revenue: "Total non-operating revenue",
        non_operating_expense: "Total non-operating expenses",
      },
      grossProfit: "Gross profit",
      operatingProfit: "Operating profit",
      profitBeforeTax: "Net profit before tax",
      incomeTax: "Income tax",
      profitAfterTax: "Net profit after tax",
      profitShort: "Profit",
      lossShort: "Loss",
      excludedWarning: "The period has posted movements outside the income statement's sections (net: {amount}) that are not shown — please review the chart of accounts.",
      failedLoad: "Failed to load the income statement",
    },
  },
  fleet: {
    maintenance: {
      pageTitle: "Vehicle Maintenance",
      title: "Maintenance register",
      addRecord: "Record maintenance",
      editRecord: "Edit record",
      car: "Vehicle",
      plateNumber: "Plate",
      serviceDate: "Service date",
      category: "Category",
      vendor: "Workshop / vendor",
      cost: "Cost",
      odometer: "Odometer (km)",
      odometerHint: "Leave empty when the workshop reported no reading \u2014 a zero here would corrupt every distance figure derived from it.",
      invoiceNo: "Invoice no.",
      notes: "Notes",
      postingState: "Ledger",
      posted: "Posted",
      unposted: "Not posted",
      journalEntry: "Entry #{id}",
      retryPost: "Retry posting",
      postRetried: "Posting retried",
      postingFailed: "The record was saved but its expense did not reach the ledger",
      allCategories: "All categories",
      allStates: "All",
      search: "Workshop, invoice, notes or plate",
      from: "From",
      to: "To",
      apply: "Apply",
      clearFilters: "Clear",
      rowsTotal: "Records shown",
      totalCost: "Total cost (shown)",
      totalPosted: "Posted (shown)",
      totalUnposted: "Not posted (shown)",
      totalsHint: "Totals cover the rows currently loaded, not the whole filtered register.",
      expenseAccount: "Expense account",
      cashAccount: "Cash account",
      missingAccounts: "Missing from the chart of accounts",
      saved: "Maintenance record saved",
      deleteTitle: "Delete record",
      deleteWarning: "Only a record that never reached the ledger can be deleted.",
      deleteConfirm: "Delete",
      deleted: "Record deleted",
      frozenHint: "This record is posted: its cost, date and vehicle can no longer be changed. Reverse the journal entry from the accounting screen first.",
      requiredFields: "Vehicle, date, category and cost are all required.",
      noRecords: "No maintenance recorded",
      failedLoad: "Could not load the maintenance register",
      failedSave: "Could not save the record",
      failedDelete: "Could not delete the record",
      failedPost: "Could not post the expense",
      failedOptions: "Could not load the categories and accounts",
      failedCars: "Could not load the vehicle list — it is empty because the request failed, not because the vehicle is missing. Try again.",
      carsTruncated: "The vehicle list shows the first {count} vehicles only — if the plate you need is missing the list is incomplete; do not pick another vehicle.",
      categories: {
        periodic: "Periodic service",
        repair: "Repair",
        tyres: "Tyres",
        oil: "Oil & filters",
        insurance: "Insurance",
        licensing: "Licensing & fees",
        other: "Other",
      },
    },
  },
  menu: {
    transferCenters: "Charge Centers",
    driversAccounting: "Drivers Accounting",
    transferCentersAccounting: "Charge Centers Accounting",
    carOwners: "Car Owners",
    businessBalances: "Business Wallet Balances",
    passengerWallets: "Passenger Wallets",
    transfers: "Transfers",
    driversTransfers: "Drivers Transfers",
    transferCentersTransfers: "Charge Centers Transfers",
    finance: "Finance",
    captainLedger: "Captain Ledger",
    chartOfAccounts: "Chart of Accounts",
    journalEntries: "Journal Entries",
    assets: "Assets",
    adjustments: "Adjustments",
    reportCatalog: "Reports",
    financeReports: "Finance Reports",
    trialBalance: "Trial Balance",
    balanceSheet: "Balance Sheet",
    incomeStatement: "Income Statement",
    generalJournalSummary: "General Journal Summary",
    driverStatement: "Driver Statement (Trips)",
    cashFlowStatement: "Cash Flow Statement",
    equityChanges: "Changes in Equity",
    accountStatement: "Account Statement",
    accountingBalance: "Accounting Balance",
    accountsInventory: "Accounts Inventory",
    autoEntries: "Auto Entries",
    periodLocks: "Period Locks",
    employees: "Employees & Payroll",
    transferAgent: "Transfer Agent",
    paymentMethods: "Payment Methods",
    headers: {
      main: "Main",
      people: "People",
      financialMarketing: "Financial & Marketing",
      operationsConfig: "Operations & Config",
    },
    requests: "Requests",
    createBooking: "Create Booking",
    bookings: "Bookings",
    bookingComplaints: "Booking Complaints",
    userComplaints: "User Complaints",
    tracking: "Tracking",
    staff: "Staff",
    roles: "Roles",
    drivers: "Drivers",
    passengers: "Passengers",
    normal: "Normal",
    businessAccounts: "Business Wallets",
    accounting: "Accounting",
    statistics: "Statistics",
    vouchers: "Vouchers",
    marketingVouchers: "Marketing Vouchers",
    personalVouchers: "Personal Vouchers",
    passengersMarketing: "Passengers Marketing",
    services: "Services",
    cameras: "Cameras (Safe Ride)",
    zones: "Zones",
    cancellationReasons: "Cancellation Reasons",
    cars: "Cars",
    carBrands: "Car Brands",
    carColors: "Car Colors",
    carMaintenance: "Maintenance",
    settings: "Settings",
  },
  // Accountant doc 2026-10-03 item 1.9: the Snap charge center gift channel.
  snapCenterGifts: {
    isCompany: "Company charge center (Snap charge center)",
    isCompanyHint: "Lets the center send gifts from a gift budget kept apart from its cash balance; every gift is booked as a company expense (Dr 51413 gifts / Cr the recipient)",
    yes: "Yes",
    no: "No",
    giftBalance: "Gift budget",
    addGiftBudget: "Adjust gift budget",
    dialogTitle: "Charge center gift budget",
    dialogHint: "Funding the gift budget posts no journal entry; the expense is booked when each gift is sent. A reduction corrects a mistake and can never take the budget below zero.",
    currentBalance: "Current gift budget",
    amount: "Amount (SYP)",
    notes: "Note",
    add: "Add",
    reduce: "Reduce (correction)",
    cancel: "Cancel",
    amountInvalid: "Enter a positive amount",
    savedToast: "Gift budget updated",
    failedToast: "Could not update the gift budget",
    companyOnTitle: "Make this a company center",
    companyOnConfirm: "This center will be able to send gifts from its gift budget, booked as a company expense. Continue?",
    companyOffTitle: "Remove the company center flag",
    companyOffConfirm: "This center will no longer be able to send gifts; its gift budget is kept. Continue?",
    companyChangedToast: "Center type updated",
    companyChangeFailed: "Could not update the center type",
    tabGiftMovements: "Gift budget movements",
    type: "Type",
    typeBUDGET_TOPUP: "Funding",
    typeBUDGET_REDUCTION: "Reduction",
    typeGIFT: "Gift",
    balanceAfter: "Budget after",
    recipient: "Recipient",
    recipientCaptain: "Driver",
    recipientPassenger: "Rider",
    operation: "Operation #",
    recipientId: "Recipient #",
    recipientBusiness: "Business",
    user: "By",
    date: "Date",
  },
  // Accountant doc 2026-10-03 item 1.5: automatic cancellation compensation.
  cancellationCompensation: {
    title: "Driver trip-cancellation compensation",
    basis: "Distance basis",
    statusBefore: "Status when cancelled",
    gpsKm: "GPS approach distance",
    referenceKm: "Reference approach (from where the driver started)",
    referenceSource: "Reference source",
    arrivedAtPickup: "\"Arrived\" pressed near the pickup",
    metersFromPickup: "{m} m from the pickup",
    yes: "Yes",
    no: "No",
    processNow: "Process compensation now",
    processNowHint: "The automatic compensation job never ran for this booking. This applies the same automatic rule now and never pays twice.",
    processed: "Compensation processed",
    processFailed: "Could not process the compensation",
    capKm: "Applied distance cap",
    approachKm: "Approach distance used",
    freeKm: "Free distance",
    billableKm: "Billable km",
    rate: "Amount per km",
    amount: "Compensation",
    journalEntry: "Journal entry",
    grantedBy: "Granted by",
    grantedAt: "Granted at",
    note: "Note",
    error: "Error",
    kmUnit: "km",
    grantKm: "Approach distance (km)",
    grantKmHint: "The distance the driver drove toward the passenger, as you established it (e.g. from the map)",
    grantNote: "Note (optional)",
    grant: "Grant compensation manually",
    grantPreview: "Expected compensation: {amount} SYP",
    granted: "Compensation granted and credited to the driver's wallet",
    grantFailed: "Could not grant the compensation",
    loadFailed: "Could not load the cancellation compensation",
    codes: {
      GRANTED: "Compensation paid",
      BELOW_THRESHOLD: "Below the free distance",
      NO_DATA: "No distance data",
      FAILED: "Processing failed",
      DISABLED: "Compensation disabled",
      NOT_CANCELLED: "Not cancelled",
      CAPTAIN_CANCELLED: "Cancelled by the driver",
      SYSTEM_CANCELLED: "Cancelled by the system",
      CC_EXCLUDED: "Call-center cancel not included",
      BEFORE_START: "Before the driver started",
      REDISTRIBUTED: "Converted to an instant order",
      NOT_PROCESSED: "Not processed",
    },
    explain: {
      GRANTED: "The compensation was credited to the driver's wallet and posted as a company expense (Dr 503 / Cr the driver's sub-account).",
      BELOW_THRESHOLD: "The driver's approach did not exceed the free distance, so no compensation is due.",
      NO_DATA: "The driver's approach could not be measured (no GPS, no estimated distance, no status locations). A user with the finance adjustments permission can grant it manually with a distance.",
      FAILED: "Processing failed and nothing was paid. It can be granted manually.",
      DISABLED: "The automatic compensation is switched off in the settings, so nothing was paid.",
      NOT_CANCELLED: "Compensation only applies to cancelled bookings.",
      CAPTAIN_CANCELLED: "The driver cancelled the booking, so no compensation is due.",
      SYSTEM_CANCELLED: "The system cancelled the booking before any driver was assigned.",
      CC_EXCLUDED: "The call center cancelled the booking, and call-center cancels are not compensated under the current settings.",
      BEFORE_START: "The booking was cancelled before the driver started toward the passenger.",
      REDISTRIBUTED: "The passenger converted the reservation into an instant order; that is a replacement, not a cancellation.",
      NOT_PROCESSED: "The booking qualifies but was not processed (cancelled before the mechanism was enabled, or the queued job never ran). A user with the finance adjustments permission can process it now or grant it manually with a distance.",
    },
    bases: {
      GPS_APPROACH: "The driver's actual GPS approach",
      ARRIVED_FULL_APPROACH: "Driver arrived at the pickup: the full approach from where he started",
      STATUS_POINTS: "Straight line between the driver's status locations",
      MANUAL: "Distance entered by an admin",
      NONE: "None",
    },
    referenceSources: {
      ESTIMATED_ROUTE_AT_START: "Route estimated when the driver started",
      STARTED_TO_PICKUP_STRAIGHT_LINE: "Straight line from the start location to the pickup",
      ACCEPT_TIME_DRIVER_DISTANCE: "Accept-time distance (started within 10 minutes of accepting)",
    },
  },
  conversation: {
    title: "Conversation",
    callLog: "Call log",
    export: "Export conversation",
    noMessages: "No messages in this conversation.",
    noCalls: "No calls for this booking.",
    passenger: "Passenger",
    captain: "Captain",
    closed: "Closed",
    active: "Active",
    sentAt: "Sent at",
    caller: "Caller",
    callee: "Callee",
    status: "Status",
    duration: "Duration",
    startedAt: "Started",
    answeredAt: "Answered",
    endedAt: "Ended",
    failReason: "Reason",
  },
  accountingPage: {
    searchNameOrAccount: "Search by name or account number (or its last digits)",
    performedBy: "Performed by",
    driversAccountingTitle: "Drivers Accounting",
    transferCentersAccountingTitle: "Charge Centers Accounting",
    driversDonePaymentsTitle: "Drivers Done Payments",
    driversPendingPaymentsTitle: "Drivers Pending Payments",
    transferCentersDonePaymentsTitle: "Charge Centers Done Payments",
    transferCentersPendingPaymentsTitle: "Charge Centers Pending Payments",
    driversTransfersTitle: "Drivers Transfers",
    transferCentersTransfersTitle: "Charge Centers Transfers",
    tabPending: "Pending",
    tabDone: "Done",
    search: "Search",
    noData: "No data available",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    email: "Email",
    name: "Name",
    type: "Type",
    balance: "Balance",
    actions: "Actions",
    date: "Date",
    amount: "Amount",
    user: "User",
    userType: "User Type",
    userName: "User Name",
    userEmail: "User Email",
    driverName: "Driver Name",
    driverPhone: "Driver Phone Number",
    accountCode: "Driver account no.",
    centerAccountCode: "Center account no.",
    transferCenterName: "Charge Center Name",
    transferCenterPhone: "Charge Center Phone",
    typeInternal: "SnapDriver",
    typeExternal: "External",
    typeDriver: "Driver",
    typeUser: "User",
    addTransfer: "Add Transfer",
    removeBalance: "Remove Balance",
    addBalance: "Add Balance",
    from: "From",
    to: "To",
    getData: "Get Data",
    exportCsv: "Export CSV",
    transferAdded: "Transfer added successfully",
    transferAddedBalance: "Transfer added. New balance: {after} (before: {before})",
    errorOccurred: "An error occurred",
    requiredField: "This field is required",
    positiveNumber: "Must be a positive number",
    invalidLength: "Invalid character length, required {len}",
    selectDateRange: "Please select a date range",
    fromBeforeTo: "From date must be before to date",
  },
  accountingShared: {
    requiredField: "Required field",
    mustBePositive: "Must be a positive number",
    invalidValue: "Invalid value",
    amount: "Amount",
    date: "Date",
    time: "Time",
    note: "Note",
    submit: "Submit",
    saved: "Saved",
    captain: "Captain",
    passenger: "Passenger",
    company: "Monaco",
    currency: "S.P",
    proceedPaymentClosing: "Proceed payment closing",
    paymentCompletedUsing: "Payment completed using",
    bank: "Bank",
    cash: "Cash",
    chooseCashRegister: "Choose cash register",
    paidNotEqualClosing: "Paid not equal closing",
    continueBtn: "Continue",
    bonusType: "Bonus type",
    onCaptainPassenger: "On captain / passenger",
    other: "Other",
    km: "KM",
    hour: "Hour",
    noteForCaptain: "Note (for captain)",
    detailsForManagement: "Details (for management)",
    bonusRequestSent: "Bonus request has been sent and requires administration approval",
    onRide: "On ride",
    onBooking: "On booking",
    bookingId: "Booking ID",
    unit: "Unit",
    rideId: "Ride ID",
    refunder: "Refunder",
    repay: "Repay",
    captainRefundDone: "Captain refund completed successfully",
    passengerRefundDone: "Passenger refund completed successfully",
    serverError: "Failed, server error",
    reportTitle: "Report",
    show: "Show",
    week: "Week",
    captainId: "Captain ID",
    paymentId: "Payment ID",
    from: "From",
    to: "To",
    ratingSummary: "({avg} from {count} ratings)",
    noRatings: "No ratings",
    restFromOldPayments: "Rest from old payments",
    revenue: "Revenue",
    meters: "Meters",
    bonus: "Bonus",
    due: "Due",
    profit: "Profit",
    cashReceived: "Cash received",
    tips: "Tips",
    penaltiesOn: "Penalties on",
    penaltiesFor: "Penalties for",
    closingBalance: "Closing balance",
    paymentDetails: "Payment details",
    reason: "Reason",
    quantity: "Quantity",
    earnings: "Earnings",
    actions: "Actions",
    details: "Details",
    dialogDetails: "{type} details",
    warning: "Warning",
    confirmQuestion: "Are you sure you want to {action}?",
    iAccept: "I accept",
    revokeRideEntries: "Revoke ride entries",
    undoRevokeRideEntries: "Undo revoke ride entries",
    revokeBonus: "Revoke bonus",
    revokePenalty: "Revoke penalty",
    revokeRideEntryAction: "revoke this ride entry",
    undoRevokeRideEntryAction: "undo the revoke of this ride entry",
    revokeBonusAction: "revoke this bonus",
    revokePenaltyAction: "revoke this penalty",
    invalidRange: "Invalid date range",
    failedGetReport: "Failed, cannot get the requested report",
    typeRides: "Rides",
    typeHours: "Hours",
    typeRidesKm: "Rides KM meter",
    typeGhostRidesKm: "Ghost rides KM meter",
    typeBonus: "Bonus",
    typePenalties: "Penalties",
    typeBookings: "Bookings",
  },
  businessPage: {
    pageTitle: "Business Wallets",
    tabRegistered: "Registered",
    tabPending: "Pending",
    tabBusinesses: "Businesses",
    registeredTitle: "Registered Business Wallets",
    pendingTitle: "Pending Business Wallets",
    colId: "ID",
    colFullName: "Full Name",
    colBusinessName: "Business Name",
    colEmployeeEstablishment: "Employee's establishment",
    colAccountNumber: "Account number",
    colAccountCode: "Establishment account no.",
    colPhoneNumber: "Phone Number",
    colEmail: "Email",
    colAccountStatus: "Account Status",
    colCreationDate: "Creation Date",
    viewProfile: "View Profile",
    genderMale: "Male",
    genderFemale: "Female",
    searchLabel: "Search business (name / type)",
    addBusiness: "Add business",
    editBusiness: "Edit business",
    pendingRechargeRequests: "Pending recharge requests",
    approve: "Approve",
    reject: "Reject",
    syp: "SYP",
    active: "Active",
    disabled: "Disabled",
    recharge: "Recharge",
    edit: "Edit",
    log: "Log",
    docs: "Docs",
    disable: "Disable",
    enable: "Enable",
    noAccounts: "No business wallets",
    name: "Name",
    type: "Type",
    phoneNumber: "Phone number",
    email: "Email",
    address: "Address",
    maxPerOrderLabel: "Max per order (SYP, blank = unlimited)",
    dailyLimitLabel: "Daily limit (SYP, blank = unlimited)",
    status: "Status",
    allowAddEmployees: "Allow adding employees",
    allowGuestForm: "Allow guest order form",
    cancel: "Cancel",
    save: "Save",
    rechargeTitle: "Recharge {name}",
    balance: "Balance",
    amountToAdd: "Amount to add (SYP)",
    noteHint: "Note (e.g. bank transfer ref)",
    addBalance: "Add balance",
    transactionsTitle: "{name} — transactions",
    noTransactions: "No transactions yet",
    documentsTitle: "{name} — documents",
    view: "View",
    download: "Download",
    delete: "Delete",
    noDocuments: "No documents",
    addDocument: "Add a document",
    titleOptional: "Title (optional)",
    chooseFile: "Choose file",
    upload: "Upload",
    docHint: "PDF, JPG, PNG, DOC/DOCX — max 10MB. Visible to admins only.",
    close: "Close",
    colBusiness: "Business",
    colAmount: "Amount",
    colNote: "Note",
    colDate: "Date",
    colName: "Name",
    colType: "Type",
    colBalance: "Balance",
    colMaxPerOrder: "Max/order",
    colDaily: "Daily",
    colStatus: "Status",
    colSize: "Size",
    typeHotel: "Hotel",
    typeHospital: "Hospital",
    typeCompany: "Company",
    typeRestaurant: "Restaurant",
    typeOffice: "Office",
    typeOther: "Other",
    statusPending: "Pending",
    statusApproved: "Approved",
    statusDisabled: "Disabled",
    txRecharge: "Recharge",
    txDebitBooking: "Booking charge",
    txAdjustment: "Adjustment",
    toastApproved: "Approved & recharged",
    toastRejected: "Rejected",
    toastFailed: "Failed",
    toastFailedLoad: "Failed to load",
    toastNameRequired: "Name is required",
    toastSaved: "Saved",
    toastEnterAmount: "Enter an amount",
    toastBalanceAdded: "Balance added",
    toastUploaded: "Uploaded",
    toastUploadFailed: "Upload failed",
    toastFailedOpen: "Failed to open",
    toastFailedDownload: "Failed to download",
    toastDeleted: "Deleted",
  },
  captainProfilePage: {
    common: {
      required: "Required",
      firstName: "First Name",
      lastName: "Last Name",
      date: "Date",
      datetime: "Datetime",
      status: "Status",
      stationId: "Station Id",
      passenger: "Passenger",
      pickUpLocation: "Pick up location",
      dropOffLocation: "Drop off location",
      rating: "Rating",
      price: "Price",
      booking: "Booking",
      bookingId: "Booking ID",
      id: "ID",
      logId: "Log ID",
      cancel: "Cancel",
      delete: "Delete",
      orderDetails: "Order Details",
      loadingData: "Loading data",
      errorTryLater: "Error, Please try later",
    },
    profile: {
      pageTitle: "Captain Profile",
      accept: "Accept",
      tabDriver: "Driver",
      tabCar: "Car",
      tabTrips: "Trips",
      tabPayments: "Payments",
      tabServices: "Services",
      information: "Information",
      phoneNumber: "Phone Number",
      email: "Email",
      type: "Type",
      gender: "Gender",
      male: "Male",
      female: "Female",
      typeInternal: "SnapDrive",
      typeExternal: "External",
      documents: "Documents",
      uploadLicenseFront: "Upload License Photo (Front)",
      uploadLicenseBack: "Upload License Photo (Back)",
      uploadIdFront: "Upload ID Card (Front)",
      uploadIdBack: "Upload ID Card (Back)",
      licenseFront: "License Photo (Front)",
      licenseBack: "License Photo (Back)",
      idCardFront: "ID Card (Front)",
      idCardBack: "ID Card (Back)",
      document: "Document",
      action: "Action",
      view: "View",
      noDocuments: "No documents uploaded.",
      save: "Save",
      brand: "Brand",
      model: "Model",
      color: "Color",
      plateNumber: "Plate Number",
      vehicleType: "Vehicle type",
      vehicleTypeCar: "Car",
      vehicleTypeMotorcycle: "Motorcycle",
      manufactureYear: "Manufacture Year",
      carOwnership: "Car ownership",
      carOwner: "Car owner",
      ownershipDriver: "Agent model - driver-owned car",
      ownershipCompany: "Principal model - company car",
      ownershipOther: "Car-owners model - registered owner's car",
      addOwnersHint: "Add owners from Car Owners page",
      saveCarInfo: "Save Car Info",
      carPicture: "Car Picture",
      changeCarPicture: "Change Car Picture",
      noCarPicture: "No car picture uploaded.",
      addService: "Add Service",
      selectService: "Select Service",
      add: "Add",
      block: "Block",
      unblock: "Unblock",
      blockDaily: "Block (7am to 7pm)",
      unblockDaily: "Unblock (7am to 7pm)",
      constraintsSaved: "Constraints saved",
      checkYourInfo: "Check your info",
      pickCarOwner: "Pick the car owner",
      noCarYetFill: "This captain has no car yet — fill: {fields}",
      savedSuccessfully: "Saved Successfully",
      carCreated: "Car created successfully",
      failedLoadServices: "Failed to load services",
      pleaseSelectService: "Please select a service",
      serviceAdded: "Service added successfully",
      failedAddService: "Failed to add service",
      serviceRemoved: "Service removed successfully",
      failedRemoveService: "Failed to remove service",
      saved: "Saved",
      somethingWentWrong: "Something Went Wrong!",
      pleaseCheckAllFields: "Please check all fields",
      captainAccepted: "Captain Accepted",
      deleteConfirmation: "Delete Confirmation",
      deleteConfirmText: "Are you sure you want to delete {name}?",
      thisService: "this service",
      changeTime: "Change Time",
      clientName: "Client name",
      serviceName: "Service Name",
      active: "Active",
      welcomeBonusLabel: "Welcome bonus",
      welcomeBonusHint: "Restricted balance granted on approval: covers the company commission only, cannot be withdrawn or transferred",
      welcomeBonusGrantedAt: "Granted on",
      welcomeBonusStatusActive: "Active",
      welcomeBonusLocked: "This amount cannot be changed after approval",
    },
    payments: {
      title: "Payments",
      meterPrice: "Meter Price",
      driverShareOfTotal: "Driver Share (of total)",
      companyPercent: "Commission revenue %",
      driverPercent: "Driver %",
      ownerPercent: "Owner %",
      companyAmount: "Company Amount",
      afterCommission: "After Commission",
      driverAmount: "Driver Amount",
      driverCommission: "Driver Commission",
      ownerCut: "Ride revenue",
      voucher: "Voucher",
      discountAmount: "Discount Amount",
      paymentType: "Payment Type",
      paymentSource: "Payment Source",
      paymentDate: "Payment Date",
      entityType: "Entity Type",
      entityId: "Entity ID",
      user: "User",
      userType: "User Type",
      driver: "Driver",
      businessPayer: "Business - {name}",
      paymentTypeWelcomeBonus: "Commission covered by welcome balance",
      paymentTypeCancellationCompensation: "Trip-cancellation compensation",
    },
    // Owner item 2.1: the restricted welcome balance card of the captain
    // profile (summary, close / approve / cancel, movements) and the
    // approval-time amount.
    welcomeBonus: {
      title: "Welcome balance (restricted)",
      granted: "Granted",
      consumed: "Used for commission",
      remaining: "Remaining",
      grantedAt: "Granted on",
      expiresAt: "Expires on",
      neverExpires: "Does not expire",
      closedAt: "Closed on",
      statusActive: "Active",
      statusExhausted: "Used up",
      statusExpired: "Expired",
      statusRevoked: "Revoked",
      restrictedNote: "Restricted balance: covers the company commission only; it cannot be withdrawn or transferred",
      closeButton: "Close remaining balance",
      closeTitle: "Close the remaining welcome balance",
      closeIntro: "The remaining {amount} will be closed and reversed in the books. The part already used is final, and the captain's wallet does not change.",
      closeApprovalNote: "If the remaining amount is above the second-approval threshold in the settings, the closure waits for another user's approval.",
      kindLabel: "Closure type",
      kindRule: "Choose the closure type",
      kindRevoke: "Revoke",
      kindExpire: "Expire",
      kindGrant: "Grant",
      kindConsume: "Commission covered",
      reason: "Reason",
      reasonRule: "Enter a reason of 3 to 500 characters",
      closeSubmit: "Close balance",
      closed: "The remaining welcome balance was closed",
      closePending: "The closure request was sent for approval",
      closeFailed: "Could not close the welcome balance",
      pendingTitle: "Closure awaiting approval",
      pendingDetail: "{kind}: {amount}, requested by {name} on {date}",
      approve: "Approve",
      approveTitle: "Approve the welcome balance closure",
      approveConfirm: "The remaining {amount} will be closed for good. The user who requested it cannot approve it.",
      approved: "Approved: the remaining balance was closed",
      approveFailed: "Could not approve the closure",
      cancelRequest: "Cancel request",
      cancelTitle: "Cancel the closure request",
      cancelConfirm: "The welcome balance stays as it is.",
      cancelled: "The closure request was cancelled",
      cancelFailed: "Could not cancel the closure request",
      noPermission: "You do not have permission for this action",
      movements: "Welcome balance movements",
      movementsFailed: "Could not load the welcome balance movements",
      noMovements: "No movements",
      movement: "Movement",
      amount: "Amount",
      remainingBefore: "Remaining before",
      remainingAfter: "Remaining after",
      by: "By",
      approvedBy: "Approved by",
      overrideWhole: "Enter an amount with at most two decimals",
      overrideAboveMax: "The welcome balance can be at most {max}",
      overrideHint: "Amount with at most two decimals",
      overrideHintMax: "Amount with at most two decimals, at most {max}",
      overrideNeedsPermission: "Changing the amount needs the welcome balance permission",
    },
    complaints: {
      category: "Category",
      count: "Count",
      close: "Close",
      submit: "Submit",
      chooseBooking: "Please choose a booking",
      chooseCategory: "Please choose a category",
    },
    schedule: {
      deleteShiftConfirm: "Do you want to delete this shift?",
      available: "Available",
      mustBeSameDay: "Must be on the same day",
    },
    chart: {
      filterByMonth: "Filter by month",
      ok: "OK",
      type: "Type",
      typeAll: "All",
      typeReservation: "Reservation",
      typeShort: "Short",
      typeInstant: "Instant",
      wrongLocation: "Wrong location",
      clientPickup: "Client pickup",
      cancelledByDriver: "Cancelled by driver",
      totalOrders: "Total orders",
      cancelledOrders: "Cancelled orders",
      completedOrders: "Completed orders",
      totalShifts: "Total shifts",
      bookingsRate: "{month} bookings rate",
      favoriteShift: "Favorite Shift",
    },
    shiftLogs: {
      filterByDay: "Filter by day",
      offline: "Offline",
      online: "Online",
      from: "From",
      to: "To",
      getData: "Get Data",
      datesInvalid: "Dates are invalid",
      tabTitle: "Shift hours",
    },
  },
  captainCreatePage: {
    pageTitleCaptains: "Captains",
    pageTitleCarRequests: "Car Requests",
    pageTitleCars: "Cars",
    driverTab: "Driver",
    vehicleTab: "Vehicle",
    driverPersonalInfo: "Driver Personal Info",
    documentsInfo: "Documents Info",
    vehicleInformation: "Vehicle Information",
    firstName: "First Name",
    lastName: "Last Name",
    phoneNumber: "Phone number",
    emailAddress: "Email address",
    licenseNumber: "License number",
    gender: "Gender",
    male: "Male",
    female: "Female",
    governorate: "Governorate",
    nationalityId: "Nationality ID",
    profileImage: "Profile image",
    idFront: "ID front",
    idBack: "ID back",
    drivingLicenseFront: "Driving license front",
    drivingLicenseBack: "Driving license back",
    proceed: "Proceed",
    selectBrand: "Select brand",
    selectModel: "Select model",
    selectCarColor: "Select car color",
    startTypingToSearch: "Start typing to search",
    plateNumber: "Plate number",
    vehicleType: "Vehicle type",
    vehicleTypeCar: "Car",
    vehicleTypeMotorcycle: "Motorcycle",
    optionalSuffix: "(optional)",
    carManufactureYear: "Car manufacture year",
    carServices: "Car services",
    carImage: "Car image",
    addCaptain: "Add captain",
    bluetoothBoxNumber: "Bluetooth box number",
    vehicleTypes: "Vehicle Types",
    constraints: "Constraints",
    technicalControlExpiryDate: "Technical control expiry date",
    renewalDocumentExpiryDate: "Renewal document expiry date",
    metrologicalLogExpiryDate: "Metrological log expiry date",
    assurance: "Assurance",
    registrationCertificate: "Registration certificate",
    technicalControl: "Technical control",
    renewalDocument: "Renewal document",
    metrologicalLog: "Metrological log",
    addCar: "Add Car",
    ruleEmail: "Please enter a valid email",
    ruleLength: "Invalid character length, required {len}",
    rulePassword: "Password must be 8-15 characters.",
    rulePhone: "Not a valid phone number !",
    ruleRequired: "This field is required",
    ruleUsernamePhone: "Phone number must start with 9 and be 9 digits",
    ruleNationalityId: "Nationality ID must be 11 digits",
    ruleLicense: "Not valid license",
    uploadAllImages: "Please upload all required images",
    captainAdded: "Captain added",
    captainCarAdded: "Captain Car added",
    checkYourInfo: "Check your info",
    search: "Search",
    id: "ID",
    captain: "Captain",
    brand: "Brand",
    model: "Model",
    color: "Color",
    number: "Number",
    insuranceExpire: "Insurance Expire",
    manuYear: "Manu. Year",
    createdAt: "Created At",
    actions: "Actions",
    approveCarTitle: "Approve car",
    denyCarTitle: "Deny car",
    approveHint: "If you approve this car, its owner can use it in his shifts",
    denyHint: "If you deny this car, its owner can't use it in his shifts and car info must be updated to approve it",
    denyReason: "Deny Reason",
    denyReasonRequired: "Deny Reason is required",
    cancel: "Cancel",
    approve: "Approve",
    deny: "Deny",
    newCar: "New car",
    carDocument: "Car Document",
    noCarDocument: "No Car Document",
    insuranceDocument: "Insurance Document",
    noInsuranceDocument: "No Insurance Document",
    insuranceExpiryDate: "Insurance Expiry Date",
    carOwnership: "Car ownership",
    ownership: "Ownership",
    carOwner: "Car owner",
    addOwnersHint: "Add owners from Car Owners page",
    saveOwnership: "Save ownership",
    driverOwnCar: "Agent model - driver-owned car",
    companyCar: "Principal model - company car",
    otherPersonCar: "Car-owners model - registered owner's car",
    setDefault: "Set default",
    updateInsuranceInfo: "Update Insurance Info",
    create: "Create",
    frontInsuranceImage: "Front Insurance Image",
    backInsuranceImage: "Back Insurance Image",
    pickCarOwner: "Pick the car owner",
    ownershipSaved: "Ownership saved",
    failedToSave: "Failed to save",
    fillAllFields: "Please Fill All Fields",
    saved: "Saved",
  },
  captainsPage: {
    driversTitle: "Drivers",
    registeredTab: "Registered",
    pendingTab: "Pending",
    registeredDriversTitle: "Registered Drivers",
    pendingDriversTitle: "Pending Drivers",
    owner: "Owner",
    new: "New",
    autonome: "Autonome",
    normalMode: "Normal",
    male: "male",
    female: "female",
    snapDriver: "SnapDriver",
    external: "External",
    statusOnline: "Online",
    statusOffline: "Offline",
    statusAtDestination: "At Destination",
    statusBusy: "Busy",
    creationDate: "Creation Date",
    email: "Email",
    wasApproved: "Was Approved",
    firstName: "First Name",
    lastName: "Last Name",
    status: "Status",
    connectionStatus: "Connection",
    phone: "Phone",
    gender: "Gender",
    type: "Type",
    licenseNumber: "License Number",
    address: "Address",
    nationalityId: "Nationality Id",
    activeColumn: "Active",
    averageRating: "Average Rating",
    accountCode: "Driver account no.",
    captainProfile: "Captain Profile",
    goToProfile: "Go To Profile",
    captainConfirmation: "Captain Confirmation",
    personalInfo: "Personal Info",
    carInfo: "Car Info",
    contract: "Contract",
    finish: "Finish",
    previousStep: "Last",
    approveAndSave: "Approve and Save",
    approveCaptain: "Approve Captain",
  },
  // Owner item 3.1: the Active / Inactive / Banned state of a registered
  // driver or rider (drivers and riders lists, both profiles).
  accountState: {
    label: "Account state",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    banned: "Banned",
    tips: {
      captain: {
        all: "Every approved driver, whatever his activity. New applications are in the Pending tab.",
        active: "Not banned, and went online, answered an order or had a trip within the activity window.",
        inactive: "Not banned, with no connection, answered order or trip within the activity window.",
        banned: "Blocked by the administration: cannot sign in.",
      },
      passenger: {
        all: "Every rider on this list, whatever his activity.",
        active: "Not banned, and placed at least one order within the activity window.",
        inactive: "Not banned, with no order within the activity window.",
        banned: "Blocked by the administration: cannot sign in.",
      },
      window: "Activity window: the last {days} days (General Settings).",
    },
    countsFailed: "Could not load the counts",
    blocked: "Account blocked",
    unblocked: "Account unblocked",
    blockTitle: "Block driver",
    blockCaptainConfirm: "Are you sure you want to block this driver's account?",
    notePlaceholder: "Reason (optional, up to 255 characters)",
    noteLabel: "Ban note",
    activeRide: "The driver has a ride in progress; block him once it ends",
    alreadyBlocked: "This driver is already blocked",
    blockFailed: "Could not change the account state",
  },
  carOwnersPage: {
    pageTitle: "Car Owners",
    searchLabel: "Search owner (name / phone)",
    newOwner: "New car owner",
    editOwner: "Edit car owner",
    name: "Name",
    phone: "Phone",
    phoneNumber: "Phone number",
    notes: "Notes",
    cars: "Cars",
    drivers: "Drivers",
    balance: "Balance",
    syp: "SYP",
    edit: "Edit",
    settle: "Settle",
    shares: "Shares",
    noOwners: "No car owners",
    cancel: "Cancel",
    save: "Save",
    settleTitle: "Settle {name}",
    amountToPayOut: "Amount to pay out (SYP)",
    payOut: "Pay out",
    sharesTitle: "{name} — Ride revenue",
    noShares: "No shares yet",
    booking: "Booking",
    driver: "Driver",
    amount: "Amount",
    date: "Date",
    failedLoad: "Failed to load",
    nameRequired: "Name is required",
    saved: "Saved",
    failed: "Failed",
    enterAmount: "Enter an amount",
    paidOut: "Paid out",
    accountCode: "Owner account no.",
    carRef: "Car ref.",
    fromDate: "From",
    toDate: "To",
    applyFilter: "Apply",
    exportExcel: "Export Excel",
    totalsTitle: "Totals",
    dailyTotals: "Daily totals",
    monthlyTotals: "Monthly totals",
    grandTotal: "Grand total",
    fromBeforeTo: "The from date must be before the to date",
  },
  createBookingPage: {
    pageTitle: "Create Booking",
    newOrder: "New Order",
    newOrderSubtitle: "Send orders through admin dashboard",
    passengerName: "Passenger's name",
    passengerNameError: "Please insert passenger's name",
    passengerPhone: "Passenger's phone number",
    passengerPhoneError: "Please insert a valid phone number",
    passengerEmail: "Passenger's email",
    passengerEmailError: "Please insert a valid email",
    timeDate: "Time / Date",
    pickup: "Pickup",
    pickupError: "Please select a valid pickup",
    selectPickup: "Select pickup",
    destination: "Destination",
    destinationError: "Please select a valid destination",
    voucherCode: "Voucher Code",
    specificDriver: "Specific Driver (optional)",
    specificDriverPlaceholder: "Send to a specific driver (optional)",
    services: "Services",
    serviceError: "Please select a service",
    estimatedPrice: "Estimated price",
    loading: "Loading...",
    send: "Send",
    savedSuccessfully: "Successfully saved",
    errorOccurred: "An error occurred",
    cantLoadServices: "Can't load services",
    createPhoneBooking: "Create Phone Booking",
    choosePassenger: "Choose Passenger",
    createPassenger: "Create Passenger",
    enterPickupLocation: "Enter Pickup Location",
    enterPickupDetails: "Enter Pickup details",
    enterPullDownLocation: "Enter Pull down Location",
    service: "Service",
    chooseDate: "Choose Date",
    chooseTime: "Choose Time",
    mobileNumberUsername: "Mobile Number (Username)",
    mobile: "Mobile",
    firstName: "First Name",
    lastName: "Last Name",
    gender: "Gender",
    birthday: "Birthday",
    birthdate: "Birthdate",
    save: "Save",
  },
  dashboardPage: {
    pageTitle: "Dashboard",
    tabBasic: "Basic",
    tabFinancial: "Financial",
    tabPassengers: "Passengers",
    tabCaptains: "Captains",
    tabMixed: "Mixed",
    tabOsm: "OSM",
    pendingRequests: "Pending requests",
    signupsToday: "Signups today",
    approvedPassengersToday: "Approved passengers today",
    unapprovedPassengersEver: "Unapproved passengers ever",
    unapprovedPassengersToday: "Unapproved passengers today",
    bookingsCountYesterday: "Bookings Count Yesterday",
    incompleteBookingsYesterday: "Incomplete bookings yesterday",
    averageRatingToday: "Average Rating Today",
    noRatingsToday: "No Ratings Today",
    weeklyFinancial: "Weekly Financial",
    from: "From",
    to: "To",
    revenue: "Revenue",
    fee: "Fee",
    payroll: "Payroll",
    discount: "Discount",
    refund: "Refund",
    penalties: "Penalties",
    bonusCaptain: "Bonus captain",
    bonusPassenger: "Bonus passenger",
    profit: "Profit",
    customizations: "Customizations",
    groupBy: "Group By",
    startDate: "Start Date",
    endDate: "End Date",
    day: "Day",
    week: "Week",
    month: "Month",
    quarter: "Quarter",
    year: "Year",
    bookings: "Bookings",
    successfulBookings: "Successful Bookings",
    rejectedBookings: "Rejected Bookings",
    acquiredVsApprovedPassengers: "Acquired vs Approved Passengers",
    activePassengers: "Active Passengers",
    passengersMonthDatetime: "Passengers (month) (Booking Datetime)",
    passengersWeekDatetime: "Passengers (week) (Booking Datetime)",
    passengersMonthCreation: "Passengers (month) (Booking Creation)",
    passengersWeekCreation: "Passengers (week) (Booking Creation)",
    bookingsCount: "Bookings Count",
    acquiredPassengers: "Acquired Passengers",
    approvedPassengers: "Approved Passengers",
    labelConst: "Const",
    labelReturning: "Returning",
    labelNew: "New",
    labelLost: "Lost",
    captainsFirstRide: "Captains first ride",
    ghostVsMeterRide: "Ghost vs Meter Ride",
    acquiredVsApprovedCaptains: "Acquired vs Approved Captains",
    activeCaptains: "Active Captains",
    onlineCaptains: "Online Captains",
    captainsWeekCheckLog: "Captains (week) (CheckLog)",
    captainsMonthCheckLog: "Captains (month) (CheckLog)",
    captainsWeekRide: "Captains (week) (Ride)",
    captainsMonthRide: "Captains (month) (Ride)",
    captainsCount: "Captains Count",
    avgGhostRide: "Avg Ghost Ride",
    avgMeterRide: "Avg Meter Ride",
    acquiredCaptains: "Acquired Captains",
    approvedCaptains: "Approved Captains",
    avgRating: "Avg Rating",
    captainRate: "Captain Rate",
    passengerRate: "Passenger Rate",
  },
  shared: {
    captainSearchFailed: "Could not search drivers",
    fields: {
      actions: "Actions",
      roles: "Roles",
      establishment_name: "Establishment name",
      establishment_id: "Establishment ID",
      status: "Status",
      doer: "Doer",
      recipient: "Recipient",
      version: "App version",
      platform: "Platform",
    },
    common: {
      loadFailed: "Could not load the data",
      search: "Search",
      cancel: "Cancel",
      save: "Save",
      saved: "Saved",
      from: "From",
      to: "To",
      date: "Date",
      time: "Time",
      next: "Next",
      other: "Other",
      apply: "Apply",
    },
    requestCard: {
      notApproved: "Not Approved",
      withDocs: "With docs",
      withoutDocs: "Without docs",
      roundTrip: "ROUND TRIP",
      requeued: "(REQUEUED)",
      acceptedSuggestion: "Accepted a suggestion",
      refusedSuggestion: "Refused a suggestion",
      noResponseSuggestion: "Hasn't responded to suggestion",
      noClass: "NO CLASS",
      eta: "(ETA +5)",
      withCaptain: "With",
      creationTime: "Creation time",
      stop: "Stop",
      voucher: "Voucher",
      paxAccepted: "Pax Accepted",
      changeTo: "->",
      toVip: "->VIP",
      toFullCar: "->FC",
      toPooling: "->P",
      changeTime: "Change Time",
      detachVoucher: "Detach voucher if needed",
      update: "Update",
      notes: "Notes",
      solve: "Solve",
      airportDetailsTitle: "Airport request details",
      agent: "Agent",
      airline: "Airline",
      paxName: "Pax name",
      paxPhone: "Pax phone",
      paxWhatsapp: "Pax whatsapp",
      ridersCount: "#Riders",
      bagsCount: "#Bags",
      pnr: "PNR",
      airportCode: "Airport code",
      estimatedPrice: "Estimated price",
      okReceived: "Ok we received",
      maxTwoHours: "Must be max of 2 hours",
      confirmUpdateService: "Are you sure you want to update the service?",
      suggestionAlreadySent: "This suggestion was already sent!",
      errorHappened: "An error happened (check error log)",
      noExtraDetails: "No extra details",
      solved: "Solved",
    },
    bookingEditor: {
      changeBookingDetails: "Change Booking Details",
      selectAction: "Select Action",
      selectAttributes: "Select Attributes",
      approveAction: "Approve Action",
      changeCaptain: "Change Captain",
      joinBooking: "Join Booking",
      changeTime: "Change Time",
      cancelBooking: "Cancel Booking",
      actionLabel: "Action",
      bookingLabel: "Booking",
      captainCancelled: "Captain Cancelled",
      fieldRequired: "This Field is Required",
      enterBookingId: "Enter booking id to join booking with",
      chooseCaptain: "Choose Captain",
      changeCaptainReason: "Change-captain Reason",
      confirmChangeCaptain: "You want to change the captain to :",
      confirmJoinRide: "You want to join ride :",
      confirmChangeTime: "You want to change the time to :",
      confirmCancelBooking: "You want to cancel this booking",
      confirmNotCancelBooking: "You don't want to cancel this booking",
      captainName: "Captain Name",
      captainNumber: "Captain Number",
      applyToAllRide: "Apply This to all bookings in same ride",
      applyPenalty: "Apply Penalty",
      penaltyApplied: "Penalty will be applied if applicable",
      penaltyNotApplied: "No penalty will be applied",
      noCancel: "No!, Get me out of here!",
      yesConfirm: "Yes!, I'm sure I want to do this",
      willBeDeleted: "Will Be Deleted!",
    },
    dataTable: {
      new: "New",
      edit: "Edit",
      noData: "No data available",
      reset: "Reset",
      deleteConfirmation: "Delete Confirmation",
      deleteConfirmText: "Are you sure you want to delete {name}?",
      thisItem: "this item",
      deleted: "Deleted",
      errorHappened: "Error Happened (Check error log)",
      fillAllFields: "Fill all fields!",
      couldntSave: "Couldn't save (error happened, check error log)!",
    },
    searchAgent: {
      searching: "Searching",
      active: "Active",
      inactive: "Inactive",
      archive: "Archive",
      username: "Username",
      email: "Email",
      firstName: "First Name",
      lastName: "Last Name",
      status: "Status",
      createdAt: "Created At",
      deletedAt: "Deleted At",
    },
    searchInput: {
      searchBookings: "Search for bookings",
      filter: "Filter",
      advancedSearch: "Advanced Search",
      noRequestsForFilters: "No requests for the selected filters",
      filters: "Filters",
      loading: "Loading...",
      clickToEditFilters: "Click to edit filters",
      loadingMoreOrders: "Loading more orders",
      endOfResults: "End of results",
      passenger: "Passenger",
      passengerPlaceholder: "Enter passenger name, phone number or email",
      driver: "Driver",
      driverPlaceholder: "Enter driver name or taxi number",
      orderId: "Order ID",
      orderIdPlaceholder: "Enter order id",
    },
  },
  passengersPage: {
    pageTitle: "Passengers",
    profileTitle: "Passenger Profile",
    marketingTitle: "Passengers Marketing",
    statsTitle: "Customer App Statistics",
    filterByEstablishment: "Filter by establishment",
    normalAccounts: "Normal Accounts",
    viewProfile: "View Profile",
    notAffiliated: "Not affiliated",
    id: "ID",
    fullName: "Full Name",
    phoneNumber: "Phone Number",
    business: "Business",
    businessName: "Business name",
    gender: "Gender",
    male: "Male",
    female: "Female",
    dateOfBirth: "Date of Birth",
    email: "Email",
    accountStatus: "Account Status",
    accountType: "Account Type",
    hotel: "Hotel",
    normal: "Normal",
    riderCode: "Rider Code",
    creationDate: "Creation Date",
    appVersion: "App version",
    active: "Active",
    inactive: "Inactive",
    archive: "Archive",
    blacklisted: "Blacklisted",
    block: "Block",
    unblock: "Unblock",
    accept: "Accept",
    save: "Save",
    saved: "Saved",
    required: "Required",
    requiredField: "Required field",
    passengerTab: "Passenger",
    tripsTab: "Trips",
    information: "Information",
    bookingId: "Booking ID",
    date: "Date",
    pickupLocation: "Pick up location",
    dropoffLocation: "Drop off location",
    driverName: "Driver Name",
    driverGlAccount: "Driver account no.",
    status: "Status",
    statusPending: "Waiting for dispatching",
    statusAccepted: "Order dispatched",
    statusStarted: "Driver is on the way",
    statusArrived: "Arrived to pickup",
    statusPickedUp: "Trip started",
    statusDone: "Arrived to dropoff",
    statusPaid: "Successful",
    statusCaptainCancelled: "Cancelled by driver",
    statusPassengerCancelled: "Cancelled by customer",
    statusSystemCancelled: "Cancelled by system",
    statusCcCancelled: "Cancelled by CC",
    blockAccount: "Block Account",
    unblockAccount: "Unblock Account",
    blockConfirm: "Are you sure you want to block this passenger account?",
    unblockConfirm: "Are you sure you want to unblock this passenger account?",
    accountBlockedSuccess: "Account Blocked Successfully",
    accountUnblockedSuccess: "Account Activated Successfully",
    statusChangeFailed: "Could not change account status",
    acceptAccount: "Accept Account",
    acceptConfirm: "Are you sure you want to accept this passenger account?",
    accountAccepted: "Account Accepted Successfully",
    acceptFailed: "Could not accept account",
    infoTitle: "{name} Info",
    passenger: "Passenger",
    captain: "Captain",
    approved: "Approved",
    yes: "Yes",
    no: "No",
    firstName: "First Name",
    username: "Username",
    birthday: "Birthday",
    certificateStart: "Certificate Start",
    certificateEnd: "Certificate End",
    idCardFront: "ID Card Front",
    idCardBack: "ID Card Back",
    noConviction: "No Conviction",
    filterPassengers: "Filter passengers",
    filterHint: "Optional filter. If disabled, message will be sent to all active passengers.",
    enableFilter: "Enable filter",
    minBookings: "Min bookings",
    fromDate: "From date",
    toDate: "To date",
    registeredFrom: "Registered from",
    registeredTo: "Registered to",
    inactiveDays: "Customers inactive for (days)",
    voucherCode: "Used discount code",
    hasUsedVoucher: "Used any discount code",
    passengerType: "Customer type",
    captainInactiveDays: "Captains inactive for (days)",
    captainStatus: "Captain status",
    targetedCount: "Targeted passengers count:",
    refreshCount: "Refresh count",
    messageContent: "Message content",
    messageHint: "Compose the marketing content and choose delivery channels.",
    message: "Message",
    sendAsSms: "Send as SMS message",
    sendAsPush: "Send as push notification",
    audienceHint: "Audience (select at least one)",
    passengers: "Passengers",
    driversSnapCaptain: "Drivers (سناب كابتن)",
    send: "Send",
    countLoadFailed: "Failed to load passengers count",
    sendCampaignTitle: "Send marketing campaign",
    sendCampaignConfirm: "Are you sure you want to send a {channels} to {target}?",
    filteredPassengers: "filtered passengers",
    allActivePassengers: "all active passengers",
    drivers: "drivers",
    channelSms: "message",
    channelPush: "notification",
    campaignQueued: "Marketing job queued successfully",
    campaignFailed: "Failed to queue marketing campaign",
    platform: "Platform",
    platformAndroid: "Android",
    platformIos: "iOS",
    language: "App language",
    languageAr: "Arabic",
    languageEn: "English",
    governorate: "Governorate",
    genderAny: "Any",
    clearFilters: "Clear filters",
    scheduleLater: "Schedule for later",
    scheduleDateTime: "Send at",
    scheduleHint: "Leave off to send now",
    presetSectionTitle: "Audience presets",
    presetName: "Preset name",
    savePreset: "Save current filters",
    loadPreset: "Load a preset",
    deletePreset: "Delete",
    presetSaved: "Preset saved",
    presetDeleted: "Preset deleted",
    presetSaveFailed: "Failed to save preset",
    presetDeleteFailed: "Failed to delete preset",
    presetNameRequired: "Enter a preset name first",
    noPresets: "No saved presets",
    campaignHistory: "Campaign history",
    campaignDate: "Date",
    campaignStatus: "Status",
    campaignChannels: "Channels",
    campaignTargeted: "Targeted",
    campaignFilters: "Filters",
    campaignMessage: "Message",
    noCampaigns: "No campaigns yet",
    refreshHistory: "Refresh",
    filtersSummaryNone: "All active (no filters)",
    // Marketing redesign (doc 2026-08-18)
    mkTemplatesTitle: "Templates",
    mkTemplatesHint: "Load a saved template with one click, or save the current setup as a new template.",
    mkSaveAsTemplate: "Save as template",
    mkUpdateTemplate: "Update template",
    mkTemplateShared: "Shared with all marketing admins",
    mkTemplateSharedHint: "Turn off to keep this template private to you",
    mkTemplateUpdated: "Template updated",
    mkTemplateUpdateFailed: "Failed to update template",
    mkCancel: "Cancel",
    mkAudienceTitle: "Target audience",
    mkSendToAll: "Send to everyone",
    mkSendToAllHint: "The notification will be sent to all active users in the system.",
    mkFilterMode: "Filter by registration date and activity",
    mkSpecificUsers: "Specific users",
    mkSpecificUsersCount: "specific users ({count})",
    mkRegisteredFromTip: "Only users who registered on or after this date",
    mkRegisteredToTip: "Only users who registered on or before this date",
    mkActivity: "Activity",
    mkActivityActive: "Active",
    mkActivityInactive: "Inactive",
    mkActivityDays: "Activity window (days)",
    mkActivityDaysHint: "Default 30 days, adjustable",
    mkActivityTip: "Inactive = no ride in the last {days} days (adjustable)",
    mkSearchUsers: "Search by name, phone number or ID",
    mkSearch: "Search",
    mkSearchNoResults: "No results",
    mkSearchFailed: "Search failed",
    mkAddUser: "Add",
    mkSelectedUsers: "Selected users",
    mkNoSelectedUsers: "No users selected yet — search and add them",
    mkRecipientsCount: "Recipients count:",
    mkViewList: "View list",
    mkExportCsv: "Export CSV",
    mkRecipientsTitle: "Recipients list",
    mkContentTitle: "Notification content",
    mkNotificationTitle: "Title",
    mkNotificationText: "Text",
    mkNotificationUrl: "Link (optional)",
    mkOptionsTitle: "Delivery options",
    mkChannelPushLabel: "Push notification",
    mkChannelInAppLabel: "In-app notification",
    mkChannelSmsLabel: "SMS message",
    mkChannelInApp: "in-app notification",
    mkDeferred: "Retry on reconnect (deferred delivery)",
    mkDeferredHint: "The notification keeps retrying for up to 24 hours and arrives as soon as the user's device comes online.",
    mkDeliveryStats: "Delivery status",
    mkStatusSent: "Sent",
    mkStatusPending: "Pending",
    mkStatusFailed: "Failed",
    mkStatusExpired: "Expired",
    mkCampaignQueued: "Queued",
    mkCampaignRunning: "Running",
    mkCampaignDone: "Done",
    mkCampaignFailed: "Failed",
    type: "Type",
    all: "All",
    reservation: "Reservation",
    instant: "Instant",
    filterBy: "Filter By",
    day: "Day",
    month: "Month",
    year: "Year",
    from: "From",
    to: "To",
    selectYear: "Select Year",
    bookingsStats: "Bookings Stats:",
    paymentsStats: "Payments Stats:",
    topCountries: "Top Countries:",
    stats: {
      allCompletedOrders: "All completed orders",
      customerAppTotalOrders: "Customer app total orders",
      customerAppCompletedOrders: "Customer app completed orders",
      customerAppCancelledOrders: "Customer app cancelled orders",
      ordersPerCustomer: "Orders per customer",
      numberOfDifferentCustomers: "Number of different customers",
      ordersPaidInside: "Orders paid inside",
      ordersPaidOutside: "Orders paid outside",
      totalPaidAmount: "Total paid amount",
      totalTipAmount: "Total tips amount",
      totalCancellationAmount: "Total cancellation amount",
      totalPaymentFeeAmount: "Total payment fees amount",
      averageAmountPerOrder: "Average amount per order",
      averageTipsPerOrder: "Average tips per order",
      difference: "Difference",
    },
  },
  requestsPage: {
    pageTitle: "Requests",
    instantOrders: "Instant Orders",
    reservation: "Reservation",
    newBooking: "New booking",
    pending: "Pending",
    dispatched: "Dispatched",
    driverOnTheWay: "Driver on the way",
    tripStarted: "Trip started",
    completed: "Completed",
    noOrders: "No orders",
    next: "Next",
  },
  ridePage: {
    pageTitle: "Order # Details",
    unpaidRideTitle: "Unpaid ride",
    unpaidRideHint: "The ride is finished and its fare was not paid. Settling it as unpaid credits the driver his share (and the car owner his) like an online payment, and books the fare on other receivables 12206.",
    settleUnpaid: "Settle as unpaid ride",
    settleUnpaidConfirmTitle: "Confirm unpaid ride",
    settleUnpaidConfirm: "The ride will be closed as paid in the system, the driver credited his share, and an automatic entry posted: Dr 12206 with the fare. The entry cannot be reversed. Continue?",
    settledUnpaid: "Ride settled as unpaid",
    settledUnpaidWithEntry: "Ride settled as unpaid - entry {ref}",
    settleUnpaidFailed: "Could not settle the ride as unpaid",
    docTitle: "Order #{id} Details | Snap",
    complaints: "Complaints",
    pendingChip: "{count} Pending",
    addComplaintLabel: "Add a complaint",
    complaintPlaceholder: "Enter complaint description...",
    addComplaint: "Add Complaint",
    complaintPending: "Pending",
    complaintResolved: "Resolved",
    createdAt: "Created:",
    by: "by",
    resolvedAt: "Resolved:",
    resolutionLabel: "Resolution:",
    resolve: "Resolve",
    noComplaints: "No complaints for this booking",
    pickupLocation: "Booking's pickup location",
    dropoffLocation: "Booking's dropoff location",
    statusAtTime: "{status} at {time}",
    noLocationForStatus: "No location recorded for this event",
    passengerRealLocation: "Customer's actual location",
    legendTripRoute: "Driven route (trip)",
    legendApproachRoute: "Approach route to customer",
    legendTripEstimate: "Suggested trip route",
    legendApproachEstimate: "Suggested approach route",
    followDriver: "Follow the driver",
    customerInCar: "Driver with the customer on board",
    liveFeedDisconnected: "Live feed disconnected - reconnecting...",
    resolveComplaintTitle: "Resolve Complaint",
    resolutionCommentLabel: "Resolution Comment (Optional)",
    resolutionPlaceholder: "Enter what was done to resolve this complaint...",
    cancel: "Cancel",
    statusPending: "Pending",
    statusAccepted: "Accepted",
    statusStarted: "Started",
    statusArrived: "Arrived to pickup",
    statusPickedUp: "Trip Started",
    statusDone: "Arrived to dropoff",
    statusPaid: "Paid",
    statusSystemCancelled: "Cancelled by system",
    statusPassengerCancelled: "Cancelled by customer",
    statusCaptainCancelled: "Cancelled by driver",
    statusCcCancelled: "Cancelled by CC",
    saved: "Saved!",
    chooseCategory: "Please choose a category",
    failedLoadComplaints: "Failed to load complaints",
    enterComplaintDescription: "Please enter a complaint description",
    complaintCreated: "Complaint created successfully",
    failedCreateComplaint: "Failed to create complaint",
    complaintResolvedToast: "Complaint resolved successfully",
    failedResolveComplaint: "Failed to resolve complaint",
    enterComplaintTitle: "Enter your complaint description",
    enterComplaint: "Enter complaint",
    soundFiles: "Sound files",
    zoomIn: "Click to zoom in",
    zoomOut: "Click to zoom out",
    fileComplaint: "File a complaint",
    status: "Status",
    notTreated: "Not Treated",
    partiallyTreated: "Partially Treated",
    treated: "Treated",
  },
  orderCardX: {
    completed: "Completed",
    cancelledByCustomer: "Cancelled by customer",
    cancelledByDriver: "Cancelled by driver",
    cancelledBySystem: "Cancelled by system",
    cancelledByCc: "Cancelled by CC",
    estimated: "Estimated",
    fareShortTrackEstimate: "Warning: this ride's GPS track is incomplete (only {gps} km recorded), so the fare was billed on the estimated distance of {billed} km. Please review the ride.",
    fareShortTrackStraight: "Warning: this ride's GPS track is incomplete (only {gps} km recorded), so the fare was billed on the straight-line distance between pickup and drop-off, {billed} km. Please review the ride.",
    fareManualCorrection: "This ride's fare was corrected with management approval: billed distance {billed} km (GPS recorded only {gps} km).",
    loading: "Loading",
    chooseDriverTitle: "Choose a driver to assign the booking for",
    driver: "Driver",
    searchDriver: "Search for a driver",
    close: "Close",
    dispatch: "Dispatch",
    cancellationReasonTitle: "Cancellation reason:",
    submit: "Submit",
    statusPending: "Waiting for dispatching",
    statusAccepted: "Order dispatched",
    statusStarted: "Driver is on the way",
    statusArrived: "Arrived to pickup",
    statusPickedUp: "Trip started",
    statusDone: "Arrived to dropoff",
    statusPaid: "Successful",
    statusCaptainCancelled: "Cancelled by driver",
    statusPassengerCancelled: "Cancelled by customer",
    statusSystemCancelled: "Cancelled by system",
    statusCcCancelled: "Cancelled by CC",
    openDetailsHint: "Open details",
    cancelOrderHint: "Click to cancel the order",
    dispatchHint: "Click to manually dispatch an order",
    orderLogsHint: "Click to view order logs",
    currency: "SYP",
    pendingReminderTooSoon: "You can't send a reminder for orders waiting for dispatching since less than 15 minutes",
    sendReminder: "Send Reminder",
    confirmReminderDrivers: "Are you sure to send a reminder to drivers?",
    confirmReminderDriver: "Are you sure to send a reminder to the driver?",
    reminderSent: "Reminder sent",
    errorOccurred: "An error occurred",
    dispatchedReminderTooSoon: "You can't send a reminder for dispatched orders before the order time",
    orderDispatched: "Order #{id} has been successfully dispatched",
    chooseReason: "Please choose a reason",
    orderCancelled: "Order #{id} has been cancelled",
    changeTimeTitle: "Change time of order #{id}",
    changeTimeParagraph: "Please select the new time for booking #<b>{id}</b>, Passenger <b>{passenger}</b> from <b>{from}</b> to <b>{to}</b> at <b>{time}</b>.",
    enterNewDatetime: "Enter new datetime",
    timeChanged: "Booking #{id} time has been changed from {from} to {to}.",
    dispatchNoDriver: "No driver available - dispatching stopped",
    dispatchNoDriverTargetRejected: "No driver available - the chosen driver rejected the order",
    dispatchNoDriverRejected: "No driver available - rejected by {count} driver(s)",
    dispatchOffering: "Being offered to a driver",
    dispatchReleasedTargetOffering: "Was directed to a specific driver who did not take it - now being offered to other drivers",
    dispatchReleasedTargetNoDriver: "Was directed to a specific driver who did not take it - reopened to other drivers, none available",
  },
  ridesListPage: {
    pageTitle: "Rides",
    documentTitle: "Bookings",
    fromDate: "From Date",
    toDate: "To Date",
    orderId: "Order ID",
    status: "Status",
    orderType: "Order Type",
    drivers: "Drivers",
    passengers: "Passengers",
    services: "Services",
    applyFilters: "Apply Filters",
    reset: "Reset",
    exportExcel: "Export Excel",
    statusPending: "Pending",
    statusAccepted: "Accepted",
    statusStarted: "Started",
    statusArrived: "Arrived",
    statusPickedUp: "Picked Up",
    statusDone: "Done",
    statusPaid: "Paid",
    statusSystemCancelled: "System Cancelled",
    statusPassengerCancelled: "Passenger Cancelled",
    statusCaptainCancelled: "Captain Cancelled",
    statusCcCancelled: "CC Cancelled",
    timeInstant: "Instant",
    timeReservation: "Reservation",
    colId: "ID",
    colPickup: "Pickup",
    colDropoff: "Dropoff",
    colDriverName: "Driver Name",
    colPassengerName: "Passenger Name",
    colService: "Service",
    colPrice: "Price",
    colDatetime: "Datetime",
    viewDetails: "View Details",
    currency: "SYP",
    complaintsTitle: "Booking Complaints",
    resolved: "Resolved",
    resolve: "Resolve",
    resolveComplaint: "Resolve Complaint",
    resolutionCommentLabel: "Resolution Comment (Optional)",
    resolutionCommentPlaceholder: "Enter what was done to resolve this complaint...",
    cancel: "Cancel",
    colBookingId: "Booking ID",
    colDescription: "Description",
    colCreatedAt: "Created At",
    colCreatedBy: "Created By",
    colActions: "Actions",
    colResolvedAt: "Resolved At",
    colResolvedBy: "Resolved By",
    colResolution: "Resolution",
    failedLoadPending: "Failed to load pending complaints",
    failedLoadResolved: "Failed to load resolved complaints",
    complaintResolved: "Complaint resolved successfully",
    failedResolve: "Failed to resolve complaint",
  },
  transferCentersPage: {
    pageTitle: "Charge Centers",
    new: "New",
    id: "ID",
    name: "Name",
    phoneNumber: "Phone Number",
    email: "Email",
    address: "Address",
    governorate: "Governorate",
    balance: "Balance",
    accountStatus: "Account Status",
    creationDate: "Creation Date",
    viewProfile: "View Profile",
    createTitle: "Create Charge Center",
    password: "Password",
    passwordConfirmation: "Password confirmation",
    locationDrag: "Location (drag the marker to set)",
    cancel: "Cancel",
    create: "Create",
    fieldRequired: "This field is required",
    validEmail: "Please enter a valid email",
    passwordMin: "Password must be at least 8 characters",
    passwordsNoMatch: "Passwords do not match",
    invalidPhone: "Not a valid phone number",
    setLocationToast: "Please set a location on the map",
    createdToast: "Charge center created",
    createFailedToast: "Could not create charge center",
    profileTitle: "Charge Center Profile",
    block: "Block",
    unblock: "Unblock",
    tabTransferCenter: "Charge Center",
    information: "Information",
    required: "Required",
    invalidEmail: "Invalid email",
    active: "Active",
    inactive: "Inactive",
    location: "Location",
    save: "Save",
    tabAdminTransfers: "Admin Transfers",
    tabCaptainsTransfers: "Captains Transfers",
    userEmail: "User Email",
    userName: "User Name",
    amount: "Amount",
    creationTime: "Creation Time",
    driverPhoneNumber: "Driver Phone Number",
    driverName: "Driver Name",
    accountCode: "Center account no.",
    driverAccountCode: "Driver account no.",
    savedToast: "Saved",
    blockAccount: "Block Account",
    unblockAccount: "Unblock Account",
    blockConfirm: "Are you sure you want to block this charge center account?",
    unblockConfirm: "Are you sure you want to unblock this charge center account?",
    accountBlockedToast: "Account blocked successfully",
    accountUnblockedToast: "Account activated successfully",
    statusChangeFailed: "Could not change account status",
  },
  walletsPage: {
    pageTitle: "Passenger Wallets",
    searchLabel: "Search rider (name / phone / rider code / id)",
    refresh: "Refresh",
    pendingRequestsTitle: "Pending cash top-up requests",
    syp: "SYP",
    approve: "Approve",
    reject: "Reject",
    log: "Log",
    noWallets: "No wallets",
    balance: "Balance",
    noteLabel: "Note (e.g. transfer ref / agent)",
    cancel: "Cancel",
    addBalance: "Add balance",
    apply: "Apply",
    statementTitle: "Wallet statement",
    noTransactions: "No transactions yet",
    rider: "Rider",
    amount: "Amount",
    channel: "Channel",
    note: "Note",
    date: "Date",
    riderNo: "Rider #",
    name: "Name",
    phone: "Phone",
    riderCode: "Rider code",
    type: "Type",
    booking: "Booking",
    reason: "Reason",
    failed: "Failed",
    failedToLoad: "Failed to load",
    approvedCredited: "Approved & credited",
    rejectedToast: "Rejected",
    enterAmount: "Enter an amount",
    balanceAdded: "Balance added",
    reasonRequired: "A reason is required",
    adjusted: "Adjusted",
  },
  shell: {
    clickToHide: "Click to hide",
    productionWarning: "YOU ARE CONNECTED TO PRODUCTION BACK-END SERVER",
    show: "Show",
    newTicket: "NEW TICKET::",
    name: "Name:",
    type: "Type:",
    onType: "On(Type):",
    onIdentifier: "On(Identifier):",
    creationDate: "Creation Date:",
    assignToMe: "Assign it to me",
    lateBookingToast: "Captain {captain} has been waiting for passenger since {time}",
    lateCaptainToast: "Captain {captain} is late for passenger {passenger} who should have been picked up by {time}",
    keepOrderTitle: "Keep order #{id} in besoin?",
    keepOrderParagraph: "Are you sure you want to keep looking for a driver for <b>order #{id}</b>?",
    orderExtended: "Order #{id} life has been extended",
  },
  auth: {
    welcomeTitle: "Welcome to the Snap Admin Dashboard",
    emailAddress: "Email address",
    password: "Password",
    confirmPassword: "Confirm password",
    verificationCode: "Verification code",
    login: "Login",
    resetPassword: "Reset Password",
    sendEmail: "Send Email",
    invalidEmail: "Please enter a valid email",
    invalidLength: "Invalid character length, required {len}",
    passwordRule: "Password must be 8-15 characters, and it must contain at least one uppercase letter, one lowercase letter, one number and one special character.",
    passwordLengthRule: "Password must be 8-15 characters.",
    passwordRequired: "Password is required",
    fieldRequired: "This field is required",
    passwordsDontMatch: "Passwords don't match",
    checkInfo: "Check your info",
    resetEmailSentToast: "We've sent you an email to reset your password.",
    resetPasswordDoneToast: "Password changed successfully.",
  },
  camerasPage: {
    pageTitle: "Cameras (Safe Ride)",
    logsTitle: "Stream Log",
    streamLogsButton: "Stream log",
    colImei: "IMEI",
    colName: "Name",
    colProvider: "Provider",
    colCar: "Car",
    colCars: "Cars",
    colStatus: "Status",
    colLastSeen: "Last seen",
    colNotes: "Notes",
    colDateCreated: "Date created",
    colBooking: "Booking",
    colPassenger: "Passenger",
    colSuccess: "Success",
    colError: "Error",
    colRequestedAt: "Requested at",
    unbound: "Not bound",
    statusUnknown: "Unknown",
    statusOnline: "Online",
    statusOffline: "Offline",
    liveUrlMissing: "The camera cloud returned no stream URL",
    liveUrlFailed: "Could not fetch the live stream URL",
    unbindTitle: "Unbind camera",
    unbindConfirm: "Unbind camera {imei} from every car it is bound to?",
    unbindDone: "Camera unbound",
    errorOccurred: "An error occurred",
    ruleRequired: "Required",
    ruleImei: "IMEI must be 8-20 digits",
    searchCarHint: "Search by plate number, brand, or the driver's name or phone",
    carsSearching: "Searching...",
    noCarMatches: "No matching car",
    carsLoadFailed: "Could not load the car list",
    multiCarHint: "Pick every record of the same physical car — one per captain who drives it — or the camera will be missing from their trips.",
    colViewer: "Viewed by (admin)",
  },
  catalogPage: {
    pageTitleServices: "Services",
    pageTitlePrices: "Prices",
    pageTitleLocations: "Locations",
    pageTitleCars: "Cars",
    pageTitlePaymentMethods: "Payment Methods",
    pageTitleCarBrands: "Car Brands",
    pageTitleBrands: "Brands",
    pageTitleModels: "Models",
    pageTitleColors: "Colors",
    pageTitleBanks: "Banks",
    pricesTitle: "{name} - Prices",
    attachedLocationsTitle: "{name} - Attached Locations",
    attachedCaptainsTitle: "{name} - Attached Captains",
    brandModelsTitle: "{name} - Models",
    new: "New",
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    save: "Save",
    from: "From",
    to: "To",
    unknown: "Unknown",
    notAvailable: "N/A",
    unloadable: "Un-loadable",
    yes: "Yes",
    no: "No",
    deleted: "Deleted",
    failed: "Failed!",
    errorOccurred: "Error occurred",
    checkYourInfo: "Check your info",
    updatedSuccessfully: "Updated Successfully",
    createdSuccessfully: "Created Successfully",
    enterValidHours: "Please enter valid hours",
    ruleRequired: "This field is required",
    ruleNumber: "Must be a number",
    rulePositiveNumber: "Must be a positive number",
    rulePercentage: "Must be 0-100",
    ruleLength: "Invalid character length, required {len}",
    colNameEn: "Name (English)",
    colNameAr: "Name (Arabic)",
    colDateCreated: "Date Created",
    colDateUpdated: "Date Updated",
    colLastDateUpdated: "Last Date Updated",
    colInfo: "Info",
    colPriority: "Priority",
    colIcon: "Icon",
    colActive: "Active",
    colSafeRide: "Safe Ride",
    safeRideHint: "Badge only: the service stays visible to passengers. The live-view button reaches the passenger only when the captain's car has a camera",
    colCompanyPercent: "Commission revenue %",
    colDriverPercent: "Driver %",
    colOwnerPercent: "Owner %",
    colMerchantAccount: "Merchant Account",
    colName: "Name",
    colCreatedAt: "Created At",
    colUpdatedAt: "Updated At",
    colCreationDate: "Creation Date",
    colBaseFare: "Base Fare (USD)",
    colWaitingCostPerMin: "Waiting Cost/Minute (USD)",
    colBookingCostPerMin: "Booking Cost/Minute (USD)",
    colBookingCostPerKm: "Booking Cost/KM (USD)",
    colMinCharge: "Minimum Charge (USD)",
    colStartTime: "Start Time",
    colEndTime: "End Time",
    colPlateNumber: "Plate Number",
    colManuYear: "Manu. Year",
    colColor: "Color",
    colCaptain: "Captain",
    colBrand: "Brand",
    colModel: "Model",
    chooseCaptain: "Choose captain",
    locationsToAdd: "Locations To Add",
    baseFare: "Base Fare",
    waitingCostPerMin: "Waiting Cost/Minute",
    bookingCostPerMin: "Booking Cost/Minute",
    bookingCostPerKm: "Booking Cost/KM",
    minCharge: "Minimum Charge",
    baseFareHint: "USD. Opening fare, charged once per ride.",
    waitingCostPerMinHint: "USD per minute. Charged for each waiting minute at the pickup once the free waiting allowance is used up.",
    bookingCostPerMinHint: "USD per minute. Charged for each minute from picking up the rider to arriving at the destination.",
    bookingCostPerKmHint: "USD per km. Charged for each km driven with the rider on board; the drive to the pickup is free.",
    minChargeHint: "USD. The lowest fare of a ride: it replaces a smaller total and is never added on top.",
    activateServiceTitle: "Activate Service",
    activateServiceConfirm: "Are you sure to activate service {name}?",
    serviceActivated: "Service is activated",
    deactivateServiceTitle: "Deactivate Service",
    inactiveServicesHint: "Inactive services are hidden from the passengers app and excluded from dispatch.",
    deactivateServiceConfirm: "Are you sure to deactivate service {name}?",
    serviceDeactivated: "Service is deactivated",
    deleteServiceTitle: "Delete Service",
    deleteServiceConfirm: "Are you sure to delete service {name}?",
    serviceDeleted: "Service is deleted",
    deleteRowTitle: "Delete Row",
    deleteRowConfirm: "Are you sure to delete this row?",
    rowDeleted: "Row is deleted",
    activatePaymentMethodTitle: "Activate Payment Method",
    activatePaymentMethodConfirm: "Are you sure to activate payment method {name}?",
    paymentMethodActivated: "Payment method is activated",
    deactivatePaymentMethodTitle: "Deactivate Payment Method",
    inactivePaymentMethodsHint: "Inactive payment methods are hidden from the passengers app.",
    deactivatePaymentMethodConfirm: "Are you sure to deactivate payment method {name}?",
    paymentMethodDeactivated: "Payment method is deactivated",
    modelsAction: "Models",
  },
  complaintsPage: {
    pageTitle: "Complaints List",
    filters: "Filters",
    selectCaptain: "Select Captain",
    choosePassenger: "Choose Passenger",
    startDate: "Start date",
    endDate: "End date",
    colId: "ID",
    colBookingId: "Booking ID",
    colLicenseNumber: "License number",
    colBookingTime: "Booking time",
    colCategory: "Category",
    colCount: "Count",
    details: "Details",
    titleBookingId: "Booking ID",
    titleWhoComplained: "Who complained",
    titleEntityId: "Captain/Order ID",
    titleDescription: "Description",
    titleUpdatedAt: "Last updated at",
    titleCreatedAt: "Created at",
    captainComplaintsTitle: "Captain Complaints",
    captainComplaintsHeading: "Captain {name} complaints:",
    colDescription: "Description",
    colDate: "Date",
    colDoer: "Doer",
    lostFoundTitle: "Lost & Found",
    newBtn: "New",
    newLostFound: "New Lost & Found",
    editLostFound: "Edit Lost & Found",
    colObject: "Object",
    colDay: "Day",
    colStartTime: "Start time",
    colEndTime: "End time",
    colCreatedBy: "Created By",
    colPassengerNumber: "Passenger Number",
    colCaptain: "Captain",
    colMessage: "Message",
    colFound: "Found",
    yes: "Yes",
    no: "No",
    edit: "Edit",
    sendReminder: "Send Reminder",
    delete: "Delete",
    deleteItemTitle: "Deleting item #{id}",
    deleteItemParagraph: "Are you sure you want to delete <b>item #{id}</b>?",
    deletedSuccessfully: "Deleted Successfully",
    somethingWentWrong: "Something went wrong",
    reminderTitle: "Sending reminder for item #{id}",
    reminderParagraph: "Are you sure you want to send a reminder for <b>item #{id}</b>?",
    sentSuccessfully: "Sent Successfully",
    object: "Object",
    message: "Message",
    captain: "Captain",
    searchForCaptain: "Search for a captain",
    passengerNumber: "Passenger Number",
    day: "Day",
    from: "From",
    to: "To",
    create: "Create",
    save: "Save",
    markAsFound: "Mark as found",
    fieldRequired: "This field is required",
    invalidLength: "Invalid character length, required {len}",
    enterValidHours: "Please enter valid hours",
    createdSuccessfully: "Created Successfully",
    savedSuccessfully: "Saved Successfully",
    checkYourInfo: "Check your info",
    byDoer: "by {doer}",
    availableSoundFiles: "Available sound files",
    playAudio: "Play audio",
    download: "Download",
    loading: "Loading",
    commentsSection: "Comments section",
    writeComment: "Write a comment",
    send: "Send",
    commentSoundFiles: "Comment sound files:",
    cancel: "Cancel",
    ok: "Ok",
    commentEmpty: "Comment text can't be empty",
    commentAdded: "Comment added!",
    savedToast: "Saved!",
    idLabel: "ID {id}",
  },
  globalsShared: {
    suggestPopup: {
      title: "Reminder: Time Suggestion (Change Time)",
      passengerName: "Passenger Name:",
      passengerWhatsapp: "Passenger Whatsapp:",
      captainName: "Captain Name:",
      originalTime: "Original Time:",
      newTime: "New Time:",
      passengerOk: "The passenger said ok",
      passengerNo: "The passenger said NO",
      noResponse: "No response yet",
    },
    snoozePopup: {
      title: "Dispatch",
      letAiDispatch: "Ok, Let AI Dispatch it",
      snooze: "Snooze",
      from: "From",
      to: "To",
      captainLocation: "Captain Location",
      minutesAbbr: "M",
    },
    dialog: {
      select: "Select",
      availableSoundFiles: "Available sound files",
      playAudio: "Play audio",
      download: "Download",
      loading: "Loading",
      cancel: "Cancel",
      ok: "Ok",
    },
    confirmPassenger: {
      title: "Passenger Confirmation",
      personalInfo: "Personal Info",
      finish: "Finish",
      previous: "Last",
      approveAndSave: "Approve and Save",
      approvePassenger: "Approve Passenger",
    },
    chooseCars: {
      startTypingToSearch: "Start typing to Search",
      cars: "Cars",
      selectedCars: "Selected Cars",
      number: "Number",
    },
    statusToggle: {
      active: "Active",
      blocked: "Blocked",
      blockTitle: "Block Account",
      activateTitle: "Activate Account",
      confirmBlock: "Are you sure you want to block this account?",
      confirmActivate: "Are you sure you want to activate this account?",
      statusChanged: "Account {status} Successfully",
      statusChangeFailed: "Could not change account status",
    },
    bookingSuggestion: {
      title: "Booking Suggestion Declined",
      captain: "Captain",
      passenger: "Passenger",
      pickup: "Pickup",
      status: "Status",
    },
    timeline: {
      day: "Day",
      from: "From",
      to: "To",
      tooltipFrom: "from",
      tooltipTo: "to",
      user: "user",
      estimatedTime: "Estimated Time",
      estimatedPrice: "Estimated Price",
      createdAt: "created at",
      bookingId: "booking id",
      rideId: "ride id",
      endOfList: "You've reached the end of the list",
      statusApproved: "APPROVED",
      statusAccepted: "ACCEPTED",
      statusStarted: "STARTED",
      statusArrived: "ARRIVED",
      statusPickedUp: "PICKED_UP",
      statusDone: "DONE",
      statusPaid: "PAID",
      statusCancelled: "CANCELLED",
      statusPaxCancelled: "PAX_CANCELLED",
      statusCaxCancelled: "CAX_CANCELLED",
      statusSystemCancelled: "SYSTEM_CANCELLED",
      statusOnline: "Online",
    },
  },
  priceRulesPage: {
    pageTitle: "Price Rules",
    newPriceRules: "New Price Rules",
    colId: "ID",
    colPullDownCluster: "Pull Down Cluster",
    colMaxPrice: "Max Price",
    colMinPrice: "Min Price",
    colMinTime: "Min Time",
    editAction: "Edit Price Rule",
    deleteAction: "Delete Price Rule",
    toastDeleted: "Price Rule Deleted Successfully",
    somethingWentWrong: "Something went wrong",
    createPageTitle: "Add Price Rule",
    createTitle: "Create New Price Rule",
    chooseCluster: "Choose Cluster",
    minPriceLabel: "Minimum Price",
    maxPriceLabel: "Maximum Price",
    minTimeLabel: "Minimum Time",
    createBtn: "Create Price Rule",
    fieldRequired: "This field is required",
    checkYourInfo: "Check your info",
    toastCreated: "Price Rule added",
    editPageTitle: "Edit Price Rules",
    minPriceFor: "Minimum Price for {cluster} Cluster",
    maxPriceFor: "Maximum Price for {cluster} Cluster",
    minTimeFor: "Minimum Time for {cluster} Cluster",
    minPriceValue: "Min Price value",
    maxPriceValue: "Max Price value",
    minTimeValue: "Min Time value",
    enterValidNumber: "Please enter a valid number",
    toastSaved: "Price Rules saved",
    toastSaveFailed: "Failed to save Price Rule",
    smsCodes: {
      pageTitle: "SMS Codes",
      colPhone: "Phone",
      colCode: "Code",
      colCreationTime: "Creation time",
      colEndTime: "End time",
    },
    notFound: {
      pageTitle: "Page Not Found",
      message: "Sorry, page not found",
      goHome: "Go Home",
    },
    noteEditor: {
      noteLabel: "Note",
      noteMinLength: "Note must be more than 3 characters",
      dateLabel: "Date",
      showOnDispatch: "Show on dispatch",
      noExpiryDate: "No expiry date",
      submitNote: "Submit Note",
    },
  },
  reservationsPage: {
    pageTitle: "Reservations",
    filterByDay: "Filter by day",
    statusPaxCancelled: "Cancelled by customer",
    statusCaptainCancelled: "Cancelled by driver",
    statusSystemCancelled: "Cancelled by CC",
    statusPending: "Waiting for dispatching",
    statusAccepted: "Order dispatched",
    statusStarted: "Driver is on the way",
    statusArrived: "Arrived to pickup",
    statusPickedUp: "Trip started",
    statusDone: "Arrived to dropoff",
    statusPaid: "Successful",
    statusDeleted: "Cancelled",
    noData: "No data available",
    transformed: "Transformed",
    normal: "Normal",
    seatsCount: "{count} passenger | {count} passengers",
    constraintEncompte: "Encompte",
    constraintLowCar: "Low car",
    constraintWheelchair: "Wheelchair",
    constraintPets: "Pets",
    constraintAmex: "AMEX",
    constraintMad: "Mad",
    constraintTest: "Test",
    comments: "Comments:",
    creationDate: "Creation date:",
    redistributeConfirm: "Redistribute order #{id}?",
    no: "No",
    yes: "Yes",
    savingChanges: "Saving changes...",
    cancellationReason: "Cancellation reason:",
    close: "Close",
    submit: "Submit",
    colId: "ID",
    colClientName: "Client name",
    colTime: "Time",
    colRoomNumber: "Room number",
    colPickup: "Pickup",
    colDropoff: "Dropoff",
    colVehicle: "Vehicle",
    colStatus: "Status",
    colTaxiNumber: "Taxi number",
    colType: "Type",
    changeTimeTitle: "Change time of order #{id}",
    changeTimeParagraph: "Please select the new time for booking #<b>{id}</b> from <b>{pickup}</b> to <b>{dropoff}</b> at <b>{time}</b>.",
    changeTimeParagraphNoDropoff: "Please select the new time for booking #<b>{id}</b> from <b>{pickup}</b> at <b>{time}</b>.",
    enterNewDatetime: "Enter new datetime",
    timeChanged: "Booking #{id} time has been changed from {from} to {to}.",
    orderRedistributed: "Order #{id} has been redistributed",
    chooseReason: "Please choose a reason",
    orderCancelled: "Order #{id} has been cancelled",
    logPageTitle: "Booking Log",
    logActionType: "Action type",
    logActorSystem: "System",
    logActorCustomerDashboard: "Customer dashboard",
    logActorAdminDashboard: "Admin dashboard",
    logStatusAccepted: "Accepted",
    logStatusRejected: "Rejected",
    logStatusNoResponse: "No response",
    logStatusPending: "Pending",
    logTypeAll: "All",
    logTypeCreateBooking: "Create Booking",
    logTypeCaptainSuggestion: "Captain Suggestion",
    logTypeManualDispatch: "Manual Dispatch",
    logColCreationDate: "Creation date",
    logColType: "Type",
    logColDoer: "Doer",
    logColRecipient: "Recipient",
    logColOldTime: "Old time",
    logColNewTime: "New time",
    blockedCaptainsTitle: "Blocked Captains",
    tabActiveBlocks: "Active blocks",
    tabHistoricalBlocks: "Historical blocks",
    username: "Username",
    colCaptainId: "Captain ID",
    colCaptainUsername: "Captain Username",
    colStationId: "Station ID",
    colOrderId: "Order ID",
    colSuggestionTime: "Suggestion Time",
    colEndTime: "End Time",
    colBlocked: "Blocked",
    dispatchingTitle: "Dispatching",
    dispatchingSettingsTitle: "Dispatching algorithms settings",
    algorithm: "Algorithm",
    chooseValue: "Choose value",
    switchTime: "Switch time",
    save: "Save",
    invalidLength: "Invalid character length, required {len}",
    fieldRequired: "This field is required",
    settingsSaved: "Settings saved",
    settingsSaveFailed: "Failed to save settings",
  },
  complaintsSystem: {
    pageTitle: "User Complaints",
    filters: {
      status: "Status",
      category: "Category",
      complainantType: "Complainant type",
      from: "From",
      to: "To",
      bookingId: "Booking ID",
      search: "Search name / phone",
      apply: "Apply",
      reset: "Reset",
    },
    columns: {
      id: "ID",
      createdAt: "Created at",
      complainant: "Complainant",
      category: "Category",
      detail: "Detail",
      booking: "Booking",
      status: "Status",
    },
    statuses: {
      NEW: "New",
      IN_REVIEW: "In review",
      RESOLVED: "Resolved",
      REJECTED: "Rejected",
    },
    complainantTypes: {
      PASSENGER: "Passenger",
      CAPTAIN: "Captain",
    },
    categories: {
      1: "App complaint",
      2: "Complaint about the driver",
      3: "Service complaint",
      4: "Complaint about the passenger",
    },
    details: {
      101: "App is slow or freezes",
      102: "Map or location errors",
      103: "Payment or wallet issue",
      104: "Notification errors",
      105: "Login issue",
      106: "App interface issue (UI/UX)",
      107: "Other",
      201: "Driver smokes",
      202: "Impolite driver",
      203: "Driver was late",
      204: "Reckless driving",
      205: "Driver doesn't know the way",
      206: "Unclean car",
      207: "No air conditioning",
      208: "Price manipulation",
      209: "Cancelled the ride without reason",
      210: "Other",
      301: "Inaccurate ride price",
      302: "Incorrect ride route",
      303: "Late car arrival",
      304: "Ride cancelled by driver",
      305: "Payment problem",
      306: "Wrong destination",
      307: "Other",
      401: "Impolite passenger",
      402: "Passenger was late",
      403: "Cancelled the ride without reason",
      404: "Changed destination without notice",
      405: "Unfair rating",
      406: "Suspicious behavior",
      407: "Other",
    },
    actionTypes: {
      CAPTAIN_FINE: "Complaint fine on captain",
      CAPTAIN_COMPENSATION: "Complaint compensation to captain",
      PASSENGER_FINE: "Complaint fine on passenger",
      PASSENGER_COMPENSATION: "Complaint compensation to passenger",
      WARNING: "Warning",
      CLOSE: "Close complaint",
    },
    detailsDialog: {
      title: "Complaint #{id}",
      complainant: "Complainant",
      against: "Against",
      phone: "Phone",
      booking: "Booking",
      createdAt: "Created at",
      resolvedAt: "Resolved at",
      category: "Category",
      detail: "Detail",
      description: "Description",
      noDescription: "No extra description.",
      attachments: "Attachments",
      noAttachments: "No attachments.",
      download: "Download",
      attachmentLoadFailed: "Failed to load attachment",
      actionsHistory: "Actions history",
      noActions: "No actions yet.",
      colType: "Action",
      colAmount: "Amount",
      colReason: "Reason",
      colAdmin: "By",
      colDate: "Date",
      startReview: "Start review",
      reject: "Reject",
      takeAction: "Take action",
      rejectConfirmTitle: "Reject complaint",
      rejectConfirmText: "Are you sure you want to reject complaint #{id}?",
      close: "Close",
    },
    actionModal: {
      title: "Take action",
      actionType: "Action type",
      amount: "Amount",
      reason: "Reason",
      submit: "Submit",
      cancel: "Cancel",
    },
    toasts: {
      loadFailed: "Failed to load complaints",
      detailsFailed: "Failed to load complaint details",
      statusUpdated: "Complaint status updated",
      actionSubmitted: "Action submitted successfully",
      actionTypeRequired: "Choose an action type",
      reasonRequired: "Reason is required",
      amountRequired: "A positive amount is required",
    },
  },
  routeTitles: {
    test: "Test",
    debugView: "Debug View",
    notifications: "Notifications",
    availableInterviewTimes: "Available Interview Times",
    interviews: "Interviews",
    timeline: "Timeline",
    pathDrawer: "Path Drawer",
    map: "Map",
    hotels: "Hotels",
    createHotel: "Create Hotel",
    editHotel: "Edit Hotel",
    users: "Users",
    createRestaurant: "Create Restaurant",
    editRestaurant: "Edit Restaurant",
    companyRequests: "Company Requests",
    companyRequest: "Company Request",
    unregisteredPassengers: "Unregistered Passengers",
    unregisteredCaptains: "Unregistered Captains",
    ticketsMonitoring: "Tickets Monitoring",
    ratingCauses: "Rating Causes",
    bonusPackages: "Bonus Packages",
    bonusPackage: "Bonus Package",
    bonuses: "Bonuses",
    bonusTimeSlices: "Bonus Time Slices",
    anas: "Conditional Bonus",
    businessBalances: "Business Wallet Balances",
    monacoEditor: "Monaco Editor",
    mapEditor: "Map Editor",
    nationalities: "Nationalities",
    locationContainers: "Location Containers",
    addLocationContainer: "Add Location Container",
    editLocationContainer: "Edit Location Container",
    landmarks: "Landmarks",
    stations: "Stations",
    addStation: "Add Station",
    editStation: "Edit Station",
    addLandmark: "Add Landmark",
    editLandmark: "Edit Landmark",
    sectors: "Sectors",
    updateSeasonalDestinations: "Update Seasonal Destinations",
    vehicleType: "Vehicle Types",
    levels: "Levels",
    changeCaptainReasons: "Change Captain Reasons",
    contractTemplate: "Contract Template",
    restrictedAreas: "Restricted Areas",
    addRestrictedArea: "Add Restricted Area",
    editRestrictedArea: "Edit Restricted Area",
    locations: "Locations",
    addLocation: "Add Location",
    editLocation: "Edit Location",
    captainsMap: "Captains Map",
    driversAnnouncements: "Drivers Announcements",
    createDriver: "Create New Driver",
    createCar: "Create New Car",
    captainCancellationReasons: "Captain Cancellation Reasons",
    cancellationReasons: "Cancellation Reasons",
    punishment: "Punishment",
    shiftsMap: "Shifts Map",
    testMaps: "Test Maps",
    events: "Events",
    createEvent: "Create Event",
    eventDetails: "Event Details",
    reservationQueue: "Reservation Queue",
    shifts: "Shifts",
    termsAndConditions: "Terms & Conditions",
    createTermsAndConditions: "Create Terms & Conditions",
    broadcast: "Broadcast",
    monitor: "Monitor",
    ridesSearch: "Rides Search",
    bookingComplaints: "Booking Complaints",
    userComplaints: "User Complaints",
    analyticsSummary: "Analytics Summary",
    messages: "Messages",
    bookingLog: "Booking Log",
    surveys: "Surveys",
    survey: "Survey",
    createSurvey: "Create Survey",
    constraints: "Constraints",
    createConstraint: "Create Constraint",
    editConstraint: "Edit Constraint",
    vacations: "Vacations",
    globalMessages: "Global Messages",
    maxBookingCount: "Max Booking Count",
    seasonalReservations: "Seasonal Reservations",
    createSeasonalReservation: "Create Seasonal Reservation",
    editSeasonalReservation: "Edit Seasonal Reservation",
    captainComplaints: "Captain Complaints",
    lostAndFound: "Lost & Found",
    createLostAndFound: "New Lost & Found",
    editLostAndFound: "Edit Lost & Found",
  },
  settingsPage: {
    pageTitle: "Settings",
    tabGeneral: "General",
    tabOnboardingVouchers: "Onboarding Vouchers",
    tabMobileVersions: "Mobile Versions",
    tabServiceCommissions: "Service Commissions",
    save: "Save",
    ruleEmail: "Please enter a valid email",
    ruleLength: "Invalid character length, required {len}",
    ruleRequired: "This field is required",
    rulePositiveNumber: "Must be a positive number",
    ruleVersion: "Must be a valid version format (e.g., 1.0.0)",
    rulePercentage: "Must be a number between 0 and 100",
    unsavedChanges: "You have unsaved changes. Are you sure you want to leave?",
    enterValidValues: "Please enter valid values",
    settingsSaved: "Settings saved",
    failedSaveSettings: "Failed to save settings",
    generalTitle: "General Settings",
    safeRideEnabled: "Safe Ride (in-car cameras)",
    safeRideEnabledHint: "Controls the live stream only. When off the camera cannot be opened, but flagged services stay visible to passengers as usual",
    targetCaptainFallback: "Release specific-driver orders to the area",
    targetCaptainFallbackHint: "When on, an order aimed at one driver is offered to the normal pool as soon as he does not take it, instead of waiting for the auto-cancel",
    proposalStaticMapEnabled: "Rendered map image in the driver's accept-order window",
    proposalStaticMapEnabledHint: "Uses the Google Static Maps service, billed per image. When off, the order card keeps its drawn schematic",
    captainRerouteEnabled: "Live re-routing in the captain app",
    captainRerouteEnabledHint: "When on, the captain app asks for a new route when the car leaves the drawn one, on the way to the rider and during the trip. When off, the route drawn when the order was accepted stays. Never changes the fare",
    fareDistanceGuardEnabled: "Fare distance guard",
    fareDistanceGuardEnabledHint: "When on, a ride in which the car did not move is billed on its measured distance (so the minimum fare) instead of the booked estimate, and the billed distance never exceeds what the ride's duration allows. When off, the old rule applies: with no GPS distance the booked estimate is billed",
    accountActivitySection: "Driver and rider activity (Active / Inactive filter)",
    captainActivityWindowDays: "Driver activity window (days)",
    captainActivityWindowDaysHint: "A driver is Active if he went online, answered an order or had a trip within this many days. Default 30",
    passengerActivityWindowDays: "Rider activity window (days)",
    passengerActivityWindowDaysHint: "A rider is Active if he placed at least one order within this many days. Default 30",
    ruleWholeDays: "Must be a whole number of days, 1 or more",
    welcomeBonusSection: "Welcome bonus for new captains",
    welcomeBonusEnabled: "Enable welcome bonus",
    welcomeBonusEnabledHint: "When on, a newly approved captain receives a restricted welcome balance: it covers the company commission on his rides only and cannot be withdrawn or transferred. Turning it off stops new grants only",
    welcomeBonusDefault: "Default welcome bonus amount (SYP)",
    welcomeBonusDefaultHint: "Granted on approval as a restricted balance that covers the company commission only and cannot be withdrawn or transferred; 0 = no bonus",
    welcomeBonusValidityDays: "Welcome balance validity (days)",
    welcomeBonusValidityDaysHint: "Days a welcome balance stays usable from its grant; after that, whatever is left is closed automatically by a daily job. Does not change expiry dates already set; 0 = never expires",
    welcomeBonusMax: "Maximum welcome balance per captain (SYP)",
    welcomeBonusMaxHint: "No captain is granted more than this, and a higher amount on the approval screen is refused; 0 = no ceiling",
    welcomeBonusMateriality: "Second-approval threshold for closing a welcome balance (SYP)",
    welcomeBonusMaterialityHint: "Closing a remaining welcome balance above this amount waits for another user holding the approval permission; 0 = no second approval",
    ruleWholeNumber: "Must be a whole number, 0 or more",
    // Operational entries doc 2026-10-03, items 1.3/1.4/1.6 (online payments).
    onlinePaymentsSection: "Online payments and ride settlement",
    onlinePaymentPendingWaitMinutes: "Wait for a pending online payment (minutes)",
    onlinePaymentPendingWaitMinutesHint: "When the rider started an online payment within this time, the driver is asked to wait before confirming the fare. Default 15",
    onlineUnconfirmedCaptainSettle: "When the driver confirms the fare of an online ride with no confirmed payment",
    onlineUnconfirmedCaptainSettleHint: "A gateway account is only debited after the gateway confirms. Cash: the ride is booked as a cash ride the driver collected. Refuse: the driver cannot finish the payment until the rider pays",
    onlineUnconfirmedSettleCash: "Book it as a cash ride (default)",
    onlineUnconfirmedSettleRefuse: "Refuse until the payment is confirmed",
    unpaidOnlineRideAfterHours: "Book an unpaid online ride as a receivable after (hours)",
    unpaidOnlineRideAfterHoursHint: "An online ride left finished with no confirmed or pending payment after this time is booked automatically as an unpaid ride (Dr 12206). 0 = off. Default 24",
    walletRequireBalanceAtBooking: "Require enough wallet balance when ordering a wallet ride",
    walletRequireBalanceAtBookingHint: "When on, a wallet ride is refused if the balance is below the estimated price. Off (default) allows the order and the rider pays the difference in cash",
    cancellationCompensationSection: "Driver trip-cancellation compensation",
    cancellationCompensationEnabled: "Compensate the driver when the passenger cancels after he started",
    cancellationCompensationEnabledHint: "When the passenger cancels after the driver started toward the pickup (or arrived), the driver's wallet is credited per km of approach above the free distance; the company bears it (Dr 503 / Cr driver account)",
    cancellationCompensationPerKm: "Compensation per km (SYP)",
    cancellationCompensationPerKmHint: "Amount credited to the driver for every billable km of approach",
    cancellationCompensationFreeKm: "Free distance (km)",
    cancellationCompensationFreeKmHint: "The first kilometres of approach that are not compensated",
    cancellationCompensationRounding: "Kilometre rounding",
    cancellationCompensationRoundingHint: "Whole kilometres only (3.7 km = 1 km above 2) or pro rata with the fraction (1.7 km)",
    cancellationCompensationRoundingFloor: "Whole kilometres only",
    cancellationCompensationRoundingProrata: "Pro rata with fractions",
    cancellationCompensationMaxKm: "Maximum compensated approach (km)",
    cancellationCompensationMaxKmHint: "No approach longer than this is counted; 0 = no ceiling",
    cancellationCompensationTolerance: "Tolerance above the reference approach distance (%)",
    cancellationCompensationToleranceHint: "The GPS approach is capped at the route from where the driver pressed Start to the pickup, plus this percentage, so detours and circling are not paid",
    cancellationCompensationArrivedRadius: "Arrival radius around the pickup (m)",
    cancellationCompensationArrivedRadiusHint: "A driver's Arrived tap counts as the whole approach only within this many metres of the rider's pickup point; outside it, the measured GPS distance is used",
    cancellationCompensationIncludeCc: "Include call-center cancellations",
    cancellationCompensationIncludeCcHint: "The system cannot tell whether a call-center cancel was the passenger's request or the driver's fault; turn on only if the center cancels at the passenger's request",
    bookingProposalTimeSeconds: "Booking proposal time in seconds",
    bookingProposalTime: "Booking proposal time",
    minReservationMinutes: "Minimum minutes for a reservation to be instant",
    minDistanceMeters: "Minimum distance to place an order (meter)",
    minDistance: "Minimum distance to place an order",
    allowedWaitingTimeMin: "Allowed waiting time (min)",
    allowedWaitingTime: "Allowed waiting time",
    exchangeRate: "Exchange rate",
    maxSearchSpaceKm: "Max search space (km)",
    maxSearchSpace: "Max search space",
    dispatchMode: "Instant dispatch mode",
    dispatchModeHint: "SEQUENTIAL = one captain at a time · HYBRID = nearest-first then broadcast",
    hybridBroadcastAfterSec: "Start broadcast after (seconds)",
    hybridBroadcastAfter: "Nearest-first exclusive window",
    broadcastBatchSize: "Captains per broadcast batch",
    // Final-version doc 2026-10-05 (dormant): DISPATCH_MAX_NO_RESPONSE_OFFERS.
    dispatchMaxNoResponseOffers: "Max re-offers of the same order to a captain who ignored it (0 = no limit)",
    dispatchMaxNoResponseOffersHint: "Instant orders only: a captain who did not answer the same order this many times is not offered it again. An explicit reject always excludes him. Default 0 = current behaviour",
    instantTimeToCancelMin:"Time to cancel for instant orders (min)",
    instantTimeToCancel: "Time to cancel for instant orders",
    reservationTimeToCancelMin: "Time to cancel for reservations (min)",
    reservationTimeToCancel: "Time to cancel for reservations",
    reservationDispatchStartTimeMin: "Reservation dispatch start time (min)",
    reservationDispatchStartTime: "Reservation dispatch start time",
    reservationSectionTitle: "Reservation reminders & confirmation",
    reservationReminderCadence: "Reminder cadence (minutes before pickup, CSV)",
    reservationReminderCadenceHint: "Escalating reminders, e.g. 120,60,30,15",
    reservationConfirmDeadline: "Confirmation deadline (min before pickup)",
    reservationConfirmDeadlineMin: "Confirmation deadline (min)",
    reservationConfirmRequired: "Require captain confirmation for reservations",
    reservationConfirmRequiredHint: "When on, the captain must confirm a scheduled ride before the deadline",
    reservationSuggestionTime: "Reservation proposal time (seconds)",
    reservationSuggestionTimeHint: "Leave empty to fall back to the instant booking proposal time",
    pricingSectionTitle: "Upfront pricing",
    upfrontPricingEnabled: "Upfront (locked) pricing enabled",
    upfrontPricingEnabledHint: "When on, the fare quoted at booking is locked; only justified extras are added at the end",
    extraKmTolerancePct: "Extra distance tolerance (%)",
    extraKmTolerancePctHint: "Extra kilometers beyond this tolerance can be charged on top of the locked fare",
    maxFareIncreasePct: "Max fare increase (%)",
    maxFareIncreasePctHint: "Cap on how much the final fare may exceed the locked quote",
    stagingAllowedPhones: "Staging allowed phones (CSV)",
    stagingAllowedPhonesHint: "Staging safety list; leave empty to keep current behavior (no effect on production)",
    ruleCsvNumbers: "Must be numbers separated by commas (e.g. 120,60,30,15)",
    maxNegativeAmountSyp: "Max negative amount (SYP)",
    maxNegativeAmount: "Max negative amount",
    snapPhone: "Snap phone",
    snapEmail: "Snap email",
    snapWhatsapp: "Snap WhatsApp",
    onboardingTitle: "Onboarding Vouchers Settings",
    voucherTitle: "Title",
    voucherCode: "Code",
    periodDays: "Period (days)",
    period: "Period",
    discountType: "Discount type",
    discountTypePercentage: "Percentage",
    discountTypeFixed: "Fixed amount",
    amount: "Amount",
    mobileVersionsTitle: "Mobile Versions Settings",
    passengerApp: "Passenger App",
    captainApp: "Captain App (Driver)",
    applePassenger: "Apple (iOS) - Passenger",
    androidPassenger: "Android - Passenger",
    appleCaptain: "Apple (iOS) - Captain",
    androidCaptain: "Android - Captain",
    updateMessagesPassenger: "Update Messages - Passenger",
    updateMessagesCaptain: "Update Messages - Captain",
    majorVersion: "Major version",
    minorVersion: "Minor version",
    generalMessageAr: "General message (Arabic)",
    generalMessageEn: "General message (English)",
    forceUpdateMessageAr: "Force update message (Arabic)",
    forceUpdateMessageEn: "Force update message (English)",
    optionalUpdateMessageAr: "Optional update message (Arabic)",
    optionalUpdateMessageEn: "Optional update message (English)",
    serviceCommissionsTitle: "Service Commissions",
    commissionsHint: "Commission revenue % is taken from the total; Driver % + Owner % split the remainder (must equal 100).",
    service: "Service",
    selectService: "Select a service",
    companyCommissionPercent: "Commission revenue (%)",
    companyCommission: "Commission revenue",
    driverCommissionPercent: "Driver commission (% of remainder)",
    driverCommission: "Driver commission",
    ownerCommissionPercent: "Car owner commission (% of remainder)",
    ownerCommission: "Car owner commission",
    remainderLine: "Driver + Owner = {sum} (must equal 100)",
    failedLoadServices: "Failed to load services",
    driverOwnerMustEqual100: "Driver % + Owner % must equal 100",
    commissionSaved: "Commission saved",
    failedSaveCommission: "Failed to save commission",
  },
  staffPage: {
    pageTitle: "Staff",
    new: "New",
    id: "ID",
    email: "Email",
    firstName: "First Name",
    lastName: "Last Name",
    gender: "Gender",
    dateOfBirth: "Date of Birth",
    phoneNumber: "Phone Number",
    joinedAt: "Joined At",
    profileImage: "Profile Image",
    password: "Password",
    role: "Role",
    blacklistedAt: "Blacklisted At",
    blacklistNote: "Blacklist Note",
    notAvailable: "N/A",
    genderShortMale: "M",
    genderShortFemale: "F",
    addStaffTitle: "Add a staff member",
    genderMale: "Male",
    genderFemale: "Female",
    create: "Create",
    cancel: "Cancel",
    ruleEmail: "Please enter a valid email",
    rulePassword: "Password must be 8-15 characters.",
    ruleRequired: "This field is required",
    staffAdded: "Staff member added",
    checkInfo: "Check your info",
    profilePageTitle: "User Profile",
    disable: "Disable",
    personalInformation: "Personal information",
    status: "Status",
    noDataAvailable: "No data available",
    active: "Active",
    inactive: "Inactive",
    documents: "Documents",
    workingContract: "Working contract",
    iban: "IBAN",
    paySlip: "Pay slip",
    planning: "Planning",
    open: "Open",
    accountDisabled: "Account Disabled Successfully",
    accountEnabled: "Account Enabled Successfully",
    saved: "Saved",
    pleaseCheckAllFields: "Please check all fields",
    colDate: "Date",
    colPickUpLocation: "Pick up location",
    colDropOffLocation: "Drop off location",
    colPassenger: "Passenger",
    colPrice: "Price",
    colRating: "Rating",
    colDatetime: "Datetime",
    colStatus: "Status",
    colStationId: "Station Id",
    captainProfile: "Captain Profile",
    rolesPageTitle: "Roles",
    colName: "Name",
    createdAt: "Created At",
    updatedAt: "Updated At",
    permissionsCount: "Permissions Count",
    permissions: "Permissions",
    permissionsBadge: "{count} Permission(s)",
  },
  statisticsPage: {
    pageTitle: "Statistics",
    analyticsSummaryTitle: "Analytics Summary",
    tabAutomaticReport: "Automatic Report",
    tabCustomReport: "Custom Report",
    tabOnlineCaptains: "Online Captains",
    tabComplaintsStats: "Complaints Statistics",
    tabCustomerAppStats: "Customer App Statistics",
    type: "Type",
    filterBy: "Filter By",
    from: "From",
    to: "To",
    selectYear: "Select Year",
    typeAll: "All",
    typeReservation: "Reservation",
    typeInstant: "Instant",
    filterDay: "Day",
    filterMonth: "Month",
    filterYear: "Year",
    driverType: "Driver Type",
    driverTypeAll: "All",
    driverTypeNormal: "Normal",
    driverTypeSeasonal: "Seasonal",
    driverTypeSpecific: "Specific",
    captain: "Captain",
    searchForCaptain: "Search for a captain",
    user: "User",
    searchForUser: "Search for a user",
    passenger: "Passenger",
    searchForPassenger: "Search for a passenger",
    exportPdf: "Export PDF",
    percentage: "Percentage",
    count: "Count",
    statKeys: {
      pending: "Pending",
      cancelled: "Cancelled",
      completed: "Completed",
    },
    sectionOrderType: "Order Type",
    instant: "Instant",
    reservation: "Reservation",
    sectionOrderStatus: "Order Status",
    created: "Created",
    completed: "Completed",
    cancelled: "Cancelled",
    sectionDestinationType: "Destination Type",
    destMc: "MC",
    destPext: "PEXT",
    destExt: "EXT",
    sectionOrderOrigin: "Order Origin",
    originCc: "CC",
    originApp: "App",
    originHotel: "Hotel",
    originCompany: "Company",
    sectionOrderCancellation: "Order Cancellation",
    ccCancelledWithReason: "CC Cancelled ({reason})",
    driverCancelledWithReason: "Driver Cancelled ({reason})",
    customerCancelled: "Customer Cancelled",
    hotelCancelled: "Hotel Cancelled",
    companyCancelled: "Company Cancelled",
    companyCancelledAuto: "Company Cancelled Auto",
    parentCancelledAuto: "Parent Cancelled Auto",
    sectionReservationType: "Reservation Type",
    reservationNormal: "Normal",
    reservationTransformed: "Transformed",
    reservationShort: "Short",
    sectionPaymentMethod: "Payment Method",
    paymentInside: "Inside",
    paymentOutside: "Outside",
    encompt: "Encompt",
    paymentFamily: "Family",
    paymentCompany: "Company",
    sectionVehicleType: "Vehicle Type",
    sectionConstraints: "Constraints",
    priorityOrder: "Priority Order",
    replacedWith2Cars: "Replaced With 2 Cars",
    sectionSpecialActions: "Special Actions",
    driverRedispatched: "Driver Redispatched",
    editedBooking: "Edited Booking",
    ccRedispatched: "CC Redispatched",
    driverTransferred: "Driver Transferred",
    driverExchanged: "Driver Exchanged",
    directDispatch: "Direct Dispatch",
    proposalRejected: "Proposal Rejected",
    noAnswerInStation: "No Answer In Station",
    noAnswerFree: "No Answer (Free, At Dest)",
    gotPunished: "Got Punished",
    clientChangedPaymentMethod: "Client Changed Payment Method",
    extAffectedToSeasonal: "EXT Affected to Seasonal",
    dispatchedTwiceSameDriver: "Dispatched twice to the same driver",
    sectionComplaints: "Complaints",
    hasComplaint: "Has Complaint",
    sectionTips: "Tips",
    withTip: "With tip",
    withoutTip: "Without tip",
    ordersDestinations: "Orders Destinations",
    ordersPickups: "Orders Pickups",
    getData: "Get Data",
    clearFilter: "Clear Filter",
    getPdf: "Get PDF",
    constraintsNotLoaded: "Constraints Not Loaded",
    vehicleTypesNotLoaded: "Vehicle Types Not Loaded",
    captainCancellationReasonsNotLoaded: "Captain cancellation reasons Not Loaded",
    fromDate: "From Date",
    toDate: "To Date",
    loadData: "Load Data",
    bookings: "Bookings",
    canceledOrders: "Canceled Orders",
    completedOrders: "Completed Orders",
    financials: "Financials",
    bookingRevenue: "Booking Revenue",
    redeemedVouchers: "Redeemed Vouchers",
    captainsProfit: "Captains Profit",
    snapProfit: "Snap Profit",
    commissionOwnership: "Commission & Ownership",
    driverShare: "Driver share",
    companyCommission: "Commission revenue",
    carOwnersShareExternal: "Car owners' share (2118)",
    companyCarsShare: "Ride revenue (company cars)",
    ownerShareTotal: "Ride revenue (total)",
    companyTotalRevenue: "Company total revenue",
    companyRevenueNote: "Company total revenue = commission revenue + company-cars ride revenue.",
    passengersDrivers: "Passengers & Drivers",
    newPassengers: "New Passengers",
    activePassengers: "Active Passengers",
    activeDrivers: "Active Drivers",
    selectDateRange: "Please select a date range",
    selectBothDates: "Please select both from and to dates",
    fromBeforeTo: "From date must be before To date",
    currency: "SYP",
  },
  vouchersPage: {
    pageTitleMarketing: "Marketing Vouchers",
    pageTitlePersonal: "Personal Vouchers",
    pageTitleMarketingPending: "Marketing Pending Vouchers",
    pageTitleMarketingExpired: "Marketing Expired Vouchers",
    pageTitlePersonalPending: "Personal Pending Vouchers",
    pageTitlePersonalExpired: "Personal Expired Vouchers",
    tabPending: "Pending",
    tabExpired: "Expired",
    new: "New",
    addVoucherTitle: "Add Voucher",
    title: "Title",
    code: "Code",
    type: "Type",
    discountType: "Discount Type",
    amount: "Amount",
    startDate: "Start Date",
    endDate: "End Date",
    useTimes: "Number of usage",
    maxRedemption: "Max Redemption",
    usedAmount: "Used Amount",
    createdBy: "Created By",
    active: "Active",
    creationDate: "Creation Date",
    passenger: "Passenger",
    searchPassengerPlaceholder: "Search for a passenger",
    add: "Add",
    cancel: "Cancel",
    discountTypePercentage: "Percentage",
    discountTypeFixed: "Fixed",
    typeDedicated: "Dedicated",
    typeOnboarding: "Onboarding",
    system: "System",
    voucherAdded: "Voucher added successfully",
    errorOccurred: "Error Occurred",
    ruleRequired: "This field is required",
    ruleNumber: "Must be a positive number",
    ruleLength: "Invalid character length, required {len}",
  },
  zonesPage: {
    pageTitle: "Zones",
    editorPageTitle: "Zones Editor",
    editorTitle: "Zone Editor",
    name: "Name",
    save: "Save",
    cancel: "Cancel",
    saveChangesQuestion: "Save changes?",
    savingChanges: "Saving changes...",
    saved: "Saved!",
    notSaved: "Not Saved",
    choosePolygon: "Choose a polygon on the map!",
    centroidInside: "Centroid location must be inside the sector area",
    required: "Required.",
    mustBeNumber: "Must be a number",
    dateCreated: "Date Created",
    dateUpdated: "Date Updated",
    lastDateUpdated: "Last Date Updated",
    cancellationReasonsTitle: "Cancellation Reasons",
    captainCancellationReasonsTitle: "Captain Cancellation Reasons",
    showDeleted: "Show Deleted",
    notAvailable: "N/A",
    textEn: "Text (English)",
    textAr: "Text (Arabic)",
    showToUser: "Show to User",
    showToCaptain: "Show to Captain",
    showToPassenger: "Show to Passenger",
    id: "ID",
    pleaseStandBy: "Please stand by",
    statusBusy: "Busy",
    statusFree: "Free",
    statusAtDestination: "At Destination",
    statusUnavailable: "Unavailable",
    notificationsTitle: "Notifications",
    allNotifications: "All",
    liveFeedDisconnected: "Live feed disconnected - reconnecting...",
    allCaptains: "All",
    captainsFetchFailed: "Could not refresh the captains list, showing the last known positions",
  },
  acquisitionPage: {
    pageTitleInterviews: "Interviews",
    pageTitleAvailableInterviews: "Available Interviews",
    pageTitleCompanyRequests: "Company Requests",
    pageTitleCompanyRequest: "Company Request",
    newStatus: "New Status",
    search: "Search",
    searchInterviewsTitle: "Search for captain interviews",
    captain: "Captain",
    updateStatusTitle: "Update existing status",
    createStatusTitle: "Create a new status",
    statusName: "Status Name",
    ruleMinThreeChars: "Must be 3 characters at least",
    colorLabel: "Color:",
    ruleRequired: "Required",
    save: "Save",
    editInterviewTitle: "Edit Interview Details",
    date: "Date",
    time: "Time",
    goToProfile: "Go to profile",
    noCaptain: "No captain",
    status: "Status",
    toastCaptainCreated: "Captain created",
    toastDeleted: "Deleted",
    toastDeleteStatusFailed: "Couldn't be deleted. Please make sure you remove all interviews with this label.",
    deleteShiftConfirm: "Do you want to delete this shift?",
    cancel: "Cancel",
    delete: "Delete",
    updateSliceTitle: "Update Slice Info",
    interviewInterval: "Interview Interval (per minute)",
    updateMaxCaptainsTitle: "Update Max Captains Per Interview",
    maxCaptainsLabel: "Max Captains (Per Interview)",
    available: "Available",
    toastSaved: "Saved!",
    toastErrorLog: "An error occurred (check the error log)",
    sameDayAlert: "Must be on the same day",
    colCompanyName: "Company Name",
    colContactName: "Contact Name",
    colEmail: "Email",
    colPhone: "Phone",
    colLegalForm: "Legal Form",
    colStreet: "Street",
    colNo: "No.",
    colPostalCode: "Postal Code",
    colCity: "City",
    colRciNo: "N° RCI",
    colCreationDate: "Creation date",
    colApprovalDate: "Approval date",
    actionCompanyRequest: "Company Request",
    approve: "Approve",
    approved: "Approved",
    information: "Information",
    id: "ID",
    additionalInfo: "Additional Info",
    rciExtract: "RCI Extract",
    open: "Open",
  },
  bonusPackagePage: {
    pageTitle: "Bonus Packages",
    conditionalBonus: "Conditional Bonus",
    search: "Search",
    new: "New",
    save: "Save",
    saved: "Saved successfully",
    noResults: "Your search for \"{search}\" found no results.",
    id: "ID",
    actions: "Actions",
    bonusesPageTitle: "Package Bonuses",
    packageBonusesTitle: "{name} Bonuses",
    addNewBonus: "Add New Bonus",
    timeSlicesAction: "Time Slices",
    minRides: "Min Rides",
    minBookings: "Min Bookings",
    minOnlineHours: "Min Online Hours",
    minRating: "Min Rating",
    minRejectRate: "Min Reject Rate",
    minCancellationRate: "Min Cancellation Rate",
    specificAreas: "Specific Areas",
    specificServices: "Specific Services",
    priseType: "Prise Type",
    priseValue: "Prise Value",
    captainsPageTitle: "Package Captains",
    packageCaptainsPre: "Captains which have",
    packageCaptainsPost: "bonus package",
    addNewCaptains: "Add new Captains",
    captains: "Captains",
    uploadCsvHint: "Or upload a CSV file (each line is a captain id)",
    joinDate: "Join date:",
    detach: "Detach",
    detachConfirm: "Are you sure you want to detach {name}?",
    captain: "Captain",
    startDate: "Start Date",
    bonusTimeSlices: "Bonus Time Slices",
    addNewTimeSlice: "Add New Time Slice",
    startTime: "Start Time",
    endTime: "End Time",
  },
  companiesPage: {
    companiesPageTitle: "Companies",
    hotelsPageTitle: "Hotels",
    companyPageTitle: "Company",
    hotelPageTitle: "Hotel",
    editHotelPageTitle: "Edit Hotel",
    new: "New",
    newHotel: "New Hotel",
    profile: "Profile",
    editHotel: "Edit Hotel",
    deleteHotel: "Delete Hotel",
    tableCompanies: "Companies",
    tableHotelsUsers: "Hotels Users",
    tableHotels: "Hotels",
    colNumber: "Number",
    colId: "ID",
    colCompanyName: "Company name",
    colHotelName: "Hotel name",
    colName: "Name",
    colPhoneNumber: "Phone Number",
    colPhone: "Phone number",
    colCreationDate: "Creation date",
    colWebsite: "Website",
    colAddress: "Address",
    colBillingEmail: "Billing Email",
    colEmail: "Email",
    colUserName: "User Name",
    colLandmark: "Landmark",
    createCompanyAccount: "Create a company account",
    createHotelAccount: "Create a hotel account",
    createNewHotel: "Create new Hotel",
    companyName: "Company name",
    managerFullName: "Manager's full name",
    email: "Email",
    password: "Password",
    address: "Address",
    addressPlaceholder: "Enter your address",
    phoneNumber: "Phone number",
    businessEmail: "Business email",
    hotelName: "Hotel name",
    hotelsLabel: "Hotels",
    selectHotelPlaceholder: "Select your hotel",
    create: "Create",
    save: "Save",
    ruleValidEmail: "Please enter a valid email",
    ruleCharLength: "Invalid character length, required {len}",
    rulePassword: "Password must be 8-15 characters.",
    rulePhone: "Not a valid phone number !",
    ruleWebsite: "Invalid website.",
    ruleRequired: "This field is required",
    toastCompanyCreated: "Company Created",
    toastCheckInfo: "Check your info",
    toastHotelCreated: "Hotel Created",
    toastHotelDeleted: "Hotel Deleted Successfully",
    toastSomethingWrong: "Something went wrong",
    toastFillData: "Please fill all the data",
    toastHotelSaved: "Hotel saved",
    toastHotelSaveFailed: "Failed to save Hotel",
  },
  debugPage: {
    estimatedTime: "Estimated time is {estimated}",
    datetime: "Date & time",
    checkResponse: "Check response",
    filter: "Filter",
    filterBoth: "Both",
    filterPassenger: "Passenger",
    filterCaptain: "Captain",
  },
  legacySettingsPage: {
    pageTitle: "Settings",
    heading: "Settings",
    tabBasic: "BASIC",
    tabAi: "AI",
    tabMobileVersions: "Mobile Apps Version Management",
    tabCaptain: "Captain",
    tabHrAccounting: "HR Accounting",
    warehouseRefresh: "Warehouse Refresh",
    differenceGoReturn: "Difference Between Go and return trip for round trips ( in minutes )",
    maxDaysBgChecked: "MAX Working Days For Background-Checked Captains",
    maxRidesBgChecked: "MAX Rides For Background-Checked Captains",
    maxCaptainLateness: "Max Captain Lateness to not give the passenger a penalty(In Minutes)",
    interviewSlice: "Interview slice (interval between interviews)",
    maxCaptainsPerInterview: "Max Captains Per Interview",
    defaultWhatsapp: "Default Whatsapp",
    successfulPoolingFactor: "Successful Pooling Factor",
    unsuccessfulPoolingFactor: "Unsuccessful Pooling Factor",
    longDistancePerKm: "What's considered a long distance (per km)",
    paymentLimit: "Payment Limit",
    landMarkRadius: "Land mark radius (in meters)",
    penaltyTimeLimit: "Penalty Time limit (in minutes)",
    minDistanceToPlaceRequest: "Min Distance To place request (in meters)",
    captainMinimumCharge: "Captain Minimum Charge (in SP)",
    smsWhenWhatsappDown: "Numbers to send message to when whatsapp server is down",
    commaSeparated: "Comma separated",
    anasBabyVoucherGenerator: "Anas baby voucher generator",
    captainSuggestionInstant: "Captain suggestion waiting time in seconds for instant orders",
    captainSuggestionReservation: "Captain suggestion waiting time in seconds for reservation orders",
    maxSetDestinationPerDay: "Max set destination per day",
    uploadIdDialogForRegisteredAfter: "Upload Id Dialog for registered after",
    aiUserId: "AI User id",
    autoDispatchAi: "Auto Dispatch (AI)",
    aiSuggestionUpdateTime: "AI Suggestion (Update Time)",
    maxTimeToDispatchAi: "MAX Time to dispatch (ai) in minutes",
    aiSnoozeDuration: "AI Snooze duration(in minutes)",
    aiBookingSnoozeDuration: "AI Realtime Booking Snooze Duration (In Seconds)",
    minDiffCreationNowAi: "Min Diff Between now and creation time for ai to dispatch (In Minutes)",
    aiCostPerMinute: "AI Cost(Per Minute)",
    aiCostPerKm: "AI Cost (Per Km)",
    aiCostPerRefusedBooking: "AI Cost (Per Refused Booking)",
    captainApp: "Captain App",
    captainAppLastUpdateVersion: "Captain App Last Update Version Code",
    captainAppLastRequiredVersion: "Captain App Last Required Version Code",
    passengerApp: "Passenger App",
    passengerAppLastUpdateVersion: "Passenger App Last Update Version Code",
    passengerAppLastRequiredVersion: "Passenger App Last Required Version Code",
    minRatingToAccept: "Min Rating To Accept Suggestions",
    minRatingToSeeDestination: "Min Rating To See Destination",
    minAcceptanceRatioToAccept: "Min Acceptance Ratio To Accept Orders",
    minAcceptanceRatioToSeeDestination: "Min Acceptance Ratio To See Destination",
    general: "General",
    numberOfDaysMonthly: "Number of Days Monthly",
    monthStartingDay: "Month Starting Days",
    maxMissedFingerprints: "Maximum Missed Fingerprints Monthly",
    maxReportingTimeDays: "Maximum Reporting Time In Days",
    dailyMeetings: "Daily Meetings:",
    startTime: "Start Time",
    maxUnjustifiedLateDays: "Max Time Of Unjustified Late Days",
    latenessPenalty: "Lateness Penalty",
    holidays: "Holidays:",
    sickDaysLimit: "Sick Days Limit",
    personalDaysLimit: "Personal Days Limit",
    save: "Save",
    toastDone: "Done!",
    toastError: "Error!",
    toastSaved: "Saved!",
    toastSaveProblem: "Problem When saving (check errorlog)",
  },
  legacyProfilePage: {
    userPageTitle: "User Profile",
    captainPageTitle: "Captain Profile",
    addNote: "Add new Note",
    applyJustifyTicket: "Apply Justify Ticket",
    userInfo: "User Info",
    usersEmail: "User's Email",
    email: "E-mail",
    firstName: "First name",
    lastName: "Last name",
    gender: "Gender",
    male: "Male",
    female: "Female",
    phoneNumber: "Phone Number",
    phone: "Phone",
    birthday: "Birthday",
    workingContract: "Working Contract",
    iban: "IBAN",
    paySlip: "Pay Slip",
    planning: "Planning",
    from: "From",
    to: "To",
    ticketsAssigned: "Tickets Assigned",
    ticketsResolved: "Tickets Resolved",
    activeTickets: "Active Tickets",
    avgTicketLifetimeHour: "Avg Ticket Lifetime(Hour)",
    rejectionRate: "Rejection Rate",
    averageDelayMinute: "Average Delay(minute)",
    tabInfo: "Info",
    tabStats: "Stats",
    tabLog: "Log",
    tabNotes: "Notes",
    tabLeaves: "Leaves",
    tabExtraHours: "Extra Hours",
    tabSalaryReport: "Salary Report",
    ruleRequired: "Required.",
    ruleEmail: "Invalid e-mail.",
    rulePhone: "Invalid Phone number (must be exactly 9 digits)",
    rulePassword: "Password must be between 6 and 32 letters",
    rulePasswordMatch: "Must match password",
    notesExpiryDate: "Expiry Date",
    notesCreatedAt: "Creation Date",
    notesAuthor: "Author",
    notesNote: "Note",
    logsDate: "Date",
    logsAction: "Action",
    logCreated: "Created new {resource} with id {id}",
    logChanged: "{event} {resource} with id {id}",
    forEver: "For Ever",
    toastSent: "SENT",
    toastSaved: "Saved",
    toastCheckFields: "Please check all fields",
    toastSavedMeta: "Saved Meta",
    loadingData: "Loading Data",
    enterMessage: "Enter message to send",
    message: "Message",
    requiredField: "Required Field",
    sendMessage: "Send Message",
    ratingSummary: "{avg} from {count} rate",
    noRatings: "no ratings",
    captainAvgSpeed: "Captain Avg Speed",
    allAvgSpeed: "All Avg Speed",
    kmh: "KM/H",
    resetPicture: "Reset Picture",
    photo: "Photo",
    selectImage: "Select Image",
    save: "Save",
    noConviction: "No Conviction",
    captainTabInfo: "Info",
    captainTabRateHistory: "Rate History",
    captainTabCheckLog: "Check Log",
    captainTabContracts: "Contracts",
    captainTabCars: "Cars",
    captainTabSchedule: "Schedule",
    captainTabRides: "Rides",
    captainTabAccounting: "Accounting",
    captainTabNotes: "Notes",
    captainTabStats: "Stats",
    captainTabTimeline: "Timeline",
    captainTabBlacklistLog: "Blacklist Log",
    captainNotFound: "captain not found",
    failedGetCaptain: "failed to get captain, please open inspect tool and take a screen shot",
    tried: "Tried",
    saved: "Saved",
    checkFields: "Please check all fields",
    checkLog: {
      checkLogsFor: "Check Logs for {name}",
      summary: "Summary",
      search: "Search",
      id: "ID",
      type: "Type",
      kilometers: "Kilometers",
      from: "From",
      to: "To",
      noResults: "Your search for \"{query}\" found no results.",
      details: "Details",
      stillOnline: "Still Online",
    },
  },
  ticketingPage: {
    pageTitle: "Ticket",
    monitoringTitle: "Ticket Monitoring",
    ticketNo: "Ticket {id}",
    info: "Info",
    name: "Name",
    type: "Type",
    rate: "Rate",
    resTickets: "Res. Tickets",
    unresTickets: "Unres. Tickets",
    ticketType: "Ticket Type",
    createdAt: "Created At",
    showRide: "Show Ride",
    onPassenger: "On Passenger",
    storedTime: "( stored time)",
    onCaptain: "On Captain",
    assignedTo: "Assigned to",
    noOne: "No one",
    ticketPath: "Ticket Path",
    takeAction: "Take Action",
    selectAction: "Select Action",
    ticketReport: "Ticket Report",
    ticketEventsLog: "Ticket Events Log",
    relatedTickets: "Related Tickets",
    noRelatedTickets: "No related tickets",
    reportUser: "User",
    reportProblem: "Problem",
    reportSolution: "Solution",
    reportDate: "Date",
    na: "N/A",
    noteTag: "(NOTE)",
    confirmClose: "Are you sure you want to close this ticket ?",
    confirmReopen: "Are you sure you want to reopen this ticket ?",
    enterMessage: "Enter message to send",
    voucherGift: "Voucher gift",
    walletBonus: "Wallet bonus",
    editRide: "Edit ride",
    givePenalty: "Give Penalty",
    revokePenalty: "Revoke Penalty",
    confirmFreeRide: "Are you sure you want to give free ride voucher?",
    confirmReassign: "Are you sure you want to reassign the ticket?",
    addingNote: "Adding note to ticket",
    changeCheckLogTime: "Change Check Log Time",
    revokeRide: "Revoke ride",
    justifyCheckLog: "Justify Check Log",
    problem: "Problem",
    problemPlaceholder: "Kindly describe the problem",
    measuresTaken: "Measures Taken",
    measuresPlaceholder: "Kindly describe what you've done in order to solve the problem",
    note: "Note",
    notePlaceholder: "Enter your note here",
    message: "Message",
    user: "User",
    typeLabel: "Type",
    amount: "Amount",
    amountSyp: "Amount (SYP)",
    confirmRevokePenalty: "Are you sure you want to revoke penalty on this booking?",
    confirmRevokeRide: "Are you sure you want to revoke ride?",
    poolingNote: "Note: if this ride is pooling all bookings will be revoked",
    updateMeterPrice: "Update Meter Price",
    meterPrice: "Meter Price",
    refunder: "Refunder",
    submit: "Submit",
    updatePaidAmount: "Update Paid Amount",
    passenger: "Passenger",
    paidAmount: "Paid Amount",
    original: "Original",
    newStart: "New Start : ",
    newEnd: "New End : ",
    close: "Close",
    continue: "Continue",
    rideDetails: "Ride Details",
    captainRefund: " ( CAPTAIN REFUND)",
    passengerRefund: " ( PASSENGER REFUND)",
    captainCashOut: " (CAPTAIN Cash out)",
    passengerCashOut: " (Passenger Cash out)",
    required: "Required",
    requiredField: "Required Field",
    requiredFieldLower: "Required field",
    invalidValue: "invalid value",
    fieldRequired: "Field is required",
    invalidInfo: "invalid info",
    done: "Done",
    ticketStatus: "Ticket Status",
    ticketsTypes: "Tickets Types",
    viewTicket: "View Ticket",
    empty: "Empty",
  },
  locationsPage: {
    restrictedAreasTitle: "Restricted Areas",
    restrictedAreaEditorTitle: "Restricted Area Editor",
    name: "Name",
    polygon: "Polygon",
    from: "From",
    to: "To",
    dateCreated: "Date Created",
    dateUpdated: "Date Updated",
    actionDuplicate: "Duplicate",
    confirmDuplicate: "Are you sure you want to duplicate this item?",
    toastDuplicated: "Duplicated",
    errorHappened: "Error Happened (Check error log)",
    save: "Save",
    cancel: "Cancel",
    saved: "Saved!",
    notSaved: "Not Saved",
    saveChangesQuestion: "Save changes ?",
    savingChanges: "Saving changes...",
    choosePolygon: "Choose Polygon on map!",
    ruleRequired: "Required.",
    ruleNumber: "Must be number",
    stationsTitle: "Stations",
    stationEditorTitle: "Station Editor",
    entrancePolygon: "Entrance Polygon",
    ejectionPolygon: "Ejection Polygon",
    landmarksTitle: "Landmarks",
    landmarkEditorTitle: "Landmark Editor",
    streetName: "Street Name",
    streetNumber: "Street Number",
    selectCity: "Select City",
    containersTitle: "Containers",
    containerListTitle: "Location Container List",
    containerEditorTitle: "Location Container Editor",
    sectorsTitle: "Sectors",
    blacklistedSectorsTitle: "Blacklisted Sectors",
    updateSeasonalDestinationsTitle: "Update Seasonal Destinations",
    destinationsTab: "Destinations",
    editSeasonalDestinations: "Edit Seasonal Destinations",
    seasonalDestinationsPlaceholder: "Seasonal Destinations",
    update: "Update",
    destinationsUpdated: "Destinations Updated",
    checkYourInfo: "Check your info",
  },
  messagingPage: {
    provider: "Provider",
    csvFile: "CSV",
    selectManually: "Select",
    choosePassengers: "Choose Passengers",
    chooseCaptains: "Choose Captains",
    csvFileHint: "CSV File (each line is an id of a {provider})",
    broadcastUse: "Broadcast Use",
    whatsappNumber: "Whatsapp Number",
    presets: "Presets",
    preset: "Preset",
    description: "Description",
    since: "Since",
    active: "active",
    message: "Message",
    submit: "Submit",
    fieldRequired: "This field is required",
    completeInfo: "Please complete the required info",
    broadcastStarted: "Broadcasting has been started successfully",
    broadcastFailed: "Failed to send, please open the inspect tool and take a screenshot",
    search: "Search",
    loading: "loading",
    seen: "Seen",
    sent: "Sent",
    sendMessagePlaceholder: "Send message",
    connectingToTwilio: "Connecting to Twilio",
    connectionErrorTwilio: "Error while connection to Twilio",
    selectConversation: "Select a conversation",
    toStartMessaging: "to start messaging",
    pageTitle: "Scheduled Messages",
    newScheduledMessage: "New Scheduled Message",
    colId: "ID",
    start: "Start",
    end: "End",
    interval: "Interval",
    deleteScheduledMessage: "Delete Scheduled Message",
    deletedSuccessfully: "Deleted Successfully",
    somethingWrong: "Something went wrong",
    createNewScheduledMessage: "Create new Scheduled Message",
    numberOfDays: "Number Of Days",
    step: "Step",
    create: "Create",
    singleTitle: "Scheduled Message",
    invalidLength: "Invalid character length, required {len}",
    enterValidHours: "Please enter valid hours",
    createdSuccessfully: "Created Successfully",
    checkYourInfo: "Check your info",
    broadcastHeading: "Broadcast",
    selectDriversHint: "Select Drivers you want to Broadcast to",
    send: "Send",
    confirmSendNotifications: "Are you sure you want to send notifications to {count} driver(s)?",
    sentSuccessfully: "Sent successfully",
    eventsPageTitle: "Event Reports",
    from: "From",
    to: "To",
    eventType: "Event Type",
    get: "Get",
    exportCSV: "Export CSV",
    weekdayAndDate: "Weekday and date",
    shift: "Shift",
    completedOrders: "# Completed orders",
    registeredDrivers: "Registered drivers",
    missingDrivers: "Missing drivers",
    activeDrivers: "Active drivers",
    extraDrivers: "Extra drivers",
    eventRange: "{type} From {start} To {end}",
    savingChanges: "Saving changes...",
    success: "Success",
    downloadFailed: "Download failed",
  },
  monitoringPage: {
    common: {
      name: "Name",
      createdAt: "Created At",
      updatedAt: "Updated At",
    },
    monitor: {
      pageTitle: "Monitor",
      onlineCaptains: "Online Captains: {online}/{available}",
      delayAvgMax: "Delay AVG/MAX: {avg}m / {max}m",
      sendTrafficNotification: "Send traffic notification to offline captains",
      target: "Target",
      delay: "Delay",
      hourlyBookings: "Hourly Bookings",
      dailyBookings: "Daily Bookings",
      editSurgeMessage: "Edit surge message:",
      broadcastUse: "Broadcast Use",
      send: "Send",
      surgeConfirm: "Are you sure you want to surge captains?",
    },
    pathDrawer: {
      pageTitle: "Path Drawer",
      selectRideType: "Select Ride Type",
      rideId: "Ride ID",
      ghostRideId: "Ghost Ride Id",
      search: "Search",
      legendPaxPick: "Pax Pick",
      legendPaxPull: "Pax Pull",
      legendPending: "Pending",
      legendAccepted: "Accepted",
      legendStarted: "Started",
      legendArrived: "Arrived",
      legendPickedUp: "Picked up",
      legendDone: "Done",
      legendStop: "Stop",
    },
    ridesSearch: {
      pageTitle: "Ride Search",
      rideId: "Ride ID",
    },
    ridesTracking: {
      pageTitle: "Rides Tracking",
    },
    ratingCauses: {
      pageTitle: "Rating Causes",
      captainRatingCauses: "Captain Rating Causes",
      passengerRatingCauses: "Passenger Rating Causes",
      cause: "Cause",
      ruleRequired: "Required field",
      ruleMinChars: "Must be 3 characters at least",
      addNewCause: "Add new Cause",
      colCreatedAt: "Created At",
    },
    anas: {
      pageTitle: "First ride pax",
      voucherAttached: "Voucher attached: {count}",
      idReminderActivated: "ID reminder conversion activated: {value}%",
      idReminderTotal: "ID reminder total: {value}",
      tableTitle: "Anas Stats",
    },
    vehicleType: {
      pageTitle: "Vehicle Type",
      colMaxSeats: "Max Seats Number",
      unloadable: "Un-loadable",
      ruleNumber: "Must be a number",
      ruleRequired: "This field is required",
    },
    nationalities: {
      pageTitle: "Nationalities",
    },
    unregisteredAgent: {
      pageTitle: "Unregistered",
    },
  },
  planningPage: {
    shiftsTitle: "Shifts",
    createEventTitle: "Create event",
    eventDetailsTitle: "Event Details",
    eventsTitle: "Events",
    shiftsMapTitle: "Event Details",
    reservationQueueTitle: "Reservation Queue",
    startDate: "Start date",
    endDate: "End date",
    shiftsCount: "Shifts",
    planType: "Plan type",
    id: "#",
    day: "Day",
    from: "From",
    to: "To",
    currentDrivers: "Current drivers",
    expectedDrivers: "Expected drivers",
    edit: "Edit",
    captainProfile: "Captain profile",
    info: "Info",
    editShiftTitle: "Change expected drivers of shift #{id}",
    editShiftParagraph: "Please enter the new number of expected drivers",
    editShiftInput: "Enter the new number",
    createEventHeadline: "Create a new event",
    eventName: "Event name",
    startShift: "Start shift",
    endShift: "End shift",
    lastApplianceDate: "Last date of appliance",
    create: "Create",
    requiredField: "This field is required",
    invalidEmail: "Please enter a valid email",
    invalidLength: "Invalid character length, required {len}",
    invalidPassword: "Password must be 8-15 characters.",
    eventCreated: "Event created",
    checkYourInfo: "Check your info",
    lastApplianceDateCol: "Last appliance date",
    registeredDrivers: "Registered drivers",
    creationDate: "Creation date",
    lastTimeToApply: "Last time to apply",
    captainsAppliedToShift: "Captains applied to this shift",
    eventsDetails: "Events details",
    startShiftDate: "Start shift date",
    endShiftDate: "End shift date",
    captainCount: "Captain count",
    captainName: "Captain name",
    applyDate: "Apply date",
    filterByDay: "Filter by day",
    captain: "Captain",
    shift: "Shift",
    paths: "Paths",
    logs: "Logs",
    bookingPickupLocation: "Booking {id} pickup location",
    bookingDropoffLocation: "Booking {id} dropoff location",
    logStatusAt: "{status} at {time}",
    bookingPathTitle: "Booking {id} path",
    statusLabel: "Status",
    pickupLocationLabel: "Pickup location",
    dropoffLocationLabel: "Dropoff location",
    createdAtLabel: "Created at",
    captainIdCol: "Captain Id",
    captainUsernameCol: "Captain username",
    captainNameCol: "Captain name",
    orderCol: "Order",
    enterNewPosition: "Enter the captain's new position",
    enterNewPositionPlaceholder: "Enter the new position",
    close: "Close",
    submit: "Submit",
  },
  restaurantsPage: {
    pageTitle: "Restaurants",
    restaurantDocTitle: "Restaurant",
    editRestaurantDocTitle: "Edit Restaurant",
    new: "New",
    newRestaurant: "New Restaurant",
    colNumber: "Number",
    colUserName: "User Name",
    colRestaurantName: "Restaurant name",
    colPhoneNumber: "Phone number",
    colCreationDate: "Creation date",
    colId: "ID",
    colName: "Name",
    colAddress: "Address",
    colLandmark: "Landmark",
    profile: "Profile",
    editRestaurant: "Edit Restaurant",
    deleteRestaurant: "Delete Restaurant",
    restaurantDeleted: "Restaurant Deleted Successfully",
    somethingWentWrong: "Something went wrong",
    createAccountTitle: "Create a restaurant account",
    createRestaurantTitle: "Create new Restaurant",
    selectRestaurant: "Restaurant",
    selectRestaurantPlaceholder: "Select your restaurant",
    email: "Email",
    password: "Password",
    phoneNumber: "Phone number",
    restaurantName: "Restaurant name",
    address: "Address",
    addressPlaceholder: "Enter your address",
    editHeading: "Restaurant Name",
    create: "Create",
    save: "Save",
    restaurantCreated: "Restaurant Created",
    restaurantSaved: "Restaurant saved",
    failedToSaveRestaurant: "Failed to save Restaurant",
    checkYourInfo: "Check your info",
    fillAllData: "Please fill all the data",
    fieldRequired: "This field is required",
    invalidEmail: "Please enter a valid email",
    invalidLength: "Invalid character length, required {len}",
    passwordLength: "Password must be 8-15 characters.",
    invalidPhone: "Not a valid phone number !",
  },
  seasonalPage: {
    newSeasonalTime: "New Seasonal Reservation Time",
    reservationAllowanceTitle: "Seasonal Reservation Allowance",
    idLabel: "ID",
    day: "Day",
    startTime: "Start time",
    endTime: "End time",
    editTimeTooltip: "Edit Seasonal Reservation Time",
    deleteTimeTooltip: "Delete Seasonal Reservation Time",
    deletedSuccess: "Deleted Successfully",
    somethingWentWrong: "Something went wrong",
    createSeasonalHeadline: "Create new Seasonal Reservation Time",
    createPageTitle: "Create Seasonal Reservation",
    editPageTitle: "Edit Seasonal Reservation",
    from: "From",
    to: "To",
    create: "Create",
    save: "Save",
    invalidHours: "Please enter valid hours",
    createdSuccess: "Created Successfully",
    savedSuccess: "Saved Successfully",
    checkInfo: "Check your info",
    fieldRequired: "This field is required",
    invalidLength: "Invalid character length, required {len}",
    changeCaptainReasonsTitle: "Change Captain Reasons",
    reason: "Reason",
    name: "Name",
    percentage: "Percentage",
    perHour: "Per Hour",
    perKm: "Per KM",
    perBooking: "Per Booking",
    newLevel: "New Level",
    addLevel: "Add Level:",
    contractTemplate: "Contract Template",
    levelSummary: "Percentage: {percentage}%, Per hour: {perHour}%, Per KM: {perKm}%, Per booking: {perBooking}",
    chooseBonusPackages: "Choose bonus packages",
    submit: "Submit",
    levelsTitle: "Levels",
    noContractTemplate: "No contract Template",
    saved: "Saved",
    genericError: "An error occurred",
    dateLabel: "Date:",
    noDataAvailable: "No Data Available",
    openFile: "Open File",
    newButton: "New",
    termsPageTitle: "Terms & Conditions",
    captainUsername: "Captain Username",
    captainName: "Captain Name",
    answer: "Answer",
    answeredAt: "Answered At",
    uploadTermsHeadline: "Upload a new Terms And Conditions",
    termsDocumentName: "Terms And Conditions",
    upload: "Upload",
    createTermsPageTitle: "Create Terms & Conditions",
    termCreated: "Term Created",
    vacationsUpcomingTab: "Upcoming Vacations",
    vacationsPastTab: "Past Vacations",
    startDate: "Start Date",
    endDate: "End Date",
    captain: "Captain",
    searchForCaptain: "Search for a captain",
    search: "Search",
    colUsername: "User Name",
    reservationTab: "Reservation",
    shortReservationTab: "Short Reservation",
    instantTab: "Instant",
    timeRange: "{from} To {to}",
    colTime: "Time",
    colMon: "Mon",
    colTue: "Tue",
    colWed: "Wed",
    colThu: "Thu",
    colFri: "Fri",
    colSat: "Sat",
    colSun: "Sun",
    updateAll: "Update All",
    updatedToast: "Updated",
  },
  surveysPage: {
    surveysTitle: "Surveys",
    surveyProfileTitle: "Survey Profile",
    createSurveyTitle: "Add Survey",
    constraintsTitle: "Constraints",
    createConstraintTitle: "Add Constraint",
    editConstraintTitle: "Edit Constraint",
    newSurvey: "New Survey",
    surveyAnswers: "Survey Answers",
    colId: "ID",
    titleLabel: "Title",
    questionLabel: "Question",
    startDateLabel: "Start Date",
    endDateLabel: "End Date",
    totalDriversAnswered: "Total Drivers Answered",
    surveyOptions: "Survey Options",
    percentage: "Percentage",
    count: "Count",
    captainUsername: "Captain Username",
    captainName: "Captain Name",
    answer: "Answer",
    answeredAt: "Answered At",
    surveyTab: "Survey",
    surveyInformation: "Survey Information",
    surveyTitleField: "Survey Title",
    surveyQuestionField: "Survey Question",
    surveyEndDate: "Survey End Date",
    surveyEndTime: "Survey End Time",
    createSurvey: "Create Survey",
    toastSurveyAdded: "Survey added",
    newConstraint: "New Constraint",
    colConstraintName: "Constraint Name",
    colAbbreviation: "Abbreviation",
    colCustomerAppMessage: "Customer App Message",
    colShownInCustomerApp: "Shown In Customer App?",
    colType: "Type",
    colStrikeThrough: "Strike Through",
    editConstraint: "Edit Constraint",
    deleteConstraint: "Delete Constraint",
    toastConstraintDeleted: "Constraint Deleted Successfully",
    toastSomethingWrong: "Something went wrong",
    constraintTab: "Constraint",
    constraintInformation: "Constraint Information",
    constraintNameField: "Constraint Name",
    constraintAbbreviationField: "Constraint Abbreviation",
    constraintCustomerAppMessageField: "Constraint Customer App Message",
    customerAppMessageField: "Customer App Message",
    canDriverEdit: "Can Driver edit it?",
    showInCustomerApp: "Show In Customer App?",
    strikeThrough: "Strike Through?",
    constraintType: "Constraint Type",
    createConstraint: "Create Constraint",
    optionYes: "Yes",
    optionNo: "No",
    editConstraintHeading: "Edit Constraint : {name}",
    save: "Save",
    toastConstraintAdded: "Constraint added",
    toastFillAllData: "Please fill all the data",
    toastConstraintSaved: "Constraint saved",
    toastFailedSaveConstraint: "Failed to save Constraint",
    toastCheckInfo: "Check your info",
    ruleRequired: "This field is required",
    ruleEmail: "Please enter a valid email",
    ruleLength: "Invalid character length, required {len}",
    rulePassword: "Password must be 8-15 characters.",
    rulePhone: "Not a valid phone number !",
    ruleLicense: "Not valid license",
  },
};